/* eslint-disable no-useless-escape */
/* Section 1: General Functions  */
import {
  OrderStatusText,
  OrderStatusResponse,
  OrderStatusTextArabic,
} from "../constants/Constants";
import { lightTheme, darkTheme } from "../global/theme";

import * as Constants from "../constants/Constants";
import * as utils from "./utils";
import moment from "moment";
import { number } from "prop-types";
import { debug } from "winston";
import $ from "jquery";
import { toast } from "react-toastify";

var numeral = require("numeral");

const options = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
export function numberFormatter(value) {
  const formatted = Number(value).toLocaleString("en", options);
  return formatted;
}
export function errorNotify(message, lang = "en") {

  toast.error(message, {
    position: toast.POSITION.BOTTOM_CENTER,
    hideProgressBar: true,
    autoClose: Constants.errorNotifyDuration,
    style: lang === "ar" ? { textAlign: "right" } : {},
  });
}
export function successNotify(message, lang = "en") {
  toast.success(message, {
    position: toast.POSITION.BOTTOM_CENTER,
    hideProgressBar: true,
    autoClose: Constants.successNotifyDuration,
    style: lang === "ar" ? { textAlign: "right" } : {},
  });
}

export function numberFormatterWithCommas(value) {
  if (isNaN(value) || value === null || value === "") return 0;
  return Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function numberFormatterWithCommasGrid(param) {
  var value = param.value;
  if (isNaN(value) || value === null || value === "") return 0;
  var val = Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return val;
}

export function numberFormatterDigits(value, numberOfDigits) {
  if (isNaN(value) || value === null || value === "") return 0;
  const formatted = Number(value).toFixed(numberOfDigits);
  return formatted;
}

export function numberFormatterWithCommasAndDigits(value, numberOfDigits) {
  if (isNaN(value) || value === null || value === "") return 0;
  let options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: numberOfDigits,
  };
  const formatted = Number(value).toLocaleString("en", options);
  return formatted;
}

export function numberFormatterWithCommasAndDigitsFixed(value, numberOfDigits) {
  if (isNaN(value) || value === null || value === "") return 0;

  let options = {
    minimumFractionDigits: numberOfDigits,
    maximumFractionDigits: numberOfDigits,
  };
  const formatted = Number(value).toLocaleString("en", options);
  return formatted;
}

export function threeDigitFormatValue(value, option = 3) {
  let option1 = {
    minimumFractionDigits: option,
    maximumFractionDigits: option,
  };

  let option2 = {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  };

  if (value === "" || value === null || value === undefined || isNaN(value)) {
    return 0;
  }

  if (value === "Total" || value === "المجموع") {
    return value;
  }

  // var rtn = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "OMAN"
  //   ? value : Number(value).toLocaleString("en", option1)

  return Number(value).toLocaleString("en", option1);
}

export function agGridSymbolLosses(params) {
  let value = params.value;
  if (params.data.Losses === "2") {
    value += " | ";
    value += "Accumulated Losses between 20% to 50% of issued capital";
  } else if (params.data.Losses === "3") {
    value += " | ";
    value += "Accumulated Losses 50% or above of issued capital";
  }
  return value;
}

export function agGridThreeDigitFormatValue(params) {

  if (params === 0) {
    return params;
  }
  let value = params.value;
  if (params.data.hasOwnProperty("CUR_CODE") || params.data.hasOwnProperty("CurCode")) {
    var CurCode = params.data.hasOwnProperty("CUR_CODE") ? params.data.CUR_CODE : params.data.CurCode
    if (CurCode === "USD" && params.colDef.field === "NetChangePerc") {
      value = threeDigitFormatValue(value, 2);
    } else {
      value = threeDigitFormatValue(value);
    }
  }else{
    value = threeDigitFormatValue(value);
  }
  // value = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "OMAN"
  //   ? params.value : threeDigitFormatValue(value);
  return value;
}

export function agGridCustomDigitFormatValue(params) {
  //
  let value = params.value;
  if (params.data.hasOwnProperty("CUR_CODE") || params.data.hasOwnProperty("CurCode")) {
    var CurCode = params.data.hasOwnProperty("CUR_CODE") ? params.data.CUR_CODE : params.data.CurCode

    if (CurCode === "USD") {

      // if (Number(params.data.LastTradePrice) < 1 && Number(params.data.LastTradePrice) != 0) {
      //   value = threeDigitFormatValue(value, 4);
      // } else if (Number(params.data.LastTradePrice) > 1 && Number(params.data.LastTradePrice) != 0) {
      //   value = threeDigitFormatValue(value, 2);
      // } else
      //   value = threeDigitFormatValue(value, 3);

      if ((Number(params.data.BidPrice) < 1 && Number(params.data.BidPrice) != 0) || (Number(params.data.OfferPrice) < 1 && Number(params.data.OfferPrice) != 0) || (Number(params.data.LastTradePrice) < 1 && Number(params.data.LastTradePrice) != 0)) {
        value = threeDigitFormatValue(value, 4);
      } else if ((Number(params.data.BidPrice) > 1 && Number(params.data.BidPrice) != 0) || (Number(params.data.OfferPrice) > 1 && Number(params.data.OfferPrice) != 0) || (Number(params.data.LastTradePrice) > 1 && Number(params.data.LastTradePrice) != 0)) {
        value = threeDigitFormatValue(value, 2);
      } else
        value = threeDigitFormatValue(value, 4);

    } else
      value = threeDigitFormatValue(value, 3);
  }
  else {
    value = threeDigitFormatValue(value, 3);
  }

  // value = (localStorage.getItem(Constants.localStorageConstants.Region)).toUpperCase() === "OMAN"
  //   ? params.value : threeDigitFormatValue(value, 3);

  return value;
}

export function qtyFormatValue(value) {
  
  if (value === "" || value === null || value === undefined) {
    return "";
  }
  if (value === "Total" || value === "المجموع") {
    return value;
  }
  return Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function agGridQtyFormatValue(params) {
  let value = params.value;
  value = qtyFormatValue(value);
  return value;
}

export function changePercentageFormatter(value) {
  if (value === "" || value === null || value === undefined) return 0;
  return value + " %";
}

export function agGridChangePercentageFormatter(params) {
  if (params.value === "" || params.value === null || params.value === undefined) {
    return agGridThreeDigitFormatValue(0);
  }

  return agGridThreeDigitFormatValue(params);
}

export function datetimeformatter(params) {
  var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(params);
  if (r && r.length === 7) {
    return new Date(
      parseInt(r[3]),
      parseInt(r[2]) - 1,
      parseInt(r[1]),
      parseInt(r[4]),
      parseInt(r[5]),
      parseInt(r[6])
    );
  }
}

export function StatusFormatter(params, isAgGrid = true, language = "en") {
  let OrderStatus = "";
  switch (isAgGrid ? params.value : params) {
    case OrderStatusResponse.Active: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Active
          : OrderStatusText.Active;
      return OrderStatus;
    }
    case OrderStatusResponse.Traded: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Traded
          : OrderStatusText.Traded;
      return OrderStatus;
    }
    case OrderStatusResponse.Canceled: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Canceled
          : OrderStatusText.Canceled;
      return OrderStatus;
    }
    case OrderStatusResponse.Suspended: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Suspended
          : OrderStatusText.Suspended;
      return OrderStatus;
    }
    case OrderStatusResponse.Expired: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Expired
          : OrderStatusText.Expired;
      return OrderStatus;
    }

    case OrderStatusResponse.Pending: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Pending
          : OrderStatusText.Pending;
      return OrderStatus;
    }

    case OrderStatusResponse.New: {
      OrderStatus =
        language === "ar" ? OrderStatusTextArabic.New : OrderStatusText.New;
      return OrderStatus;
    }

    case OrderStatusResponse.Outstanding: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Outstanding
          : OrderStatusText.Outstanding;
      return OrderStatus;
    }

    case OrderStatusResponse.Partially_Filled: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Partially_Filled
          : OrderStatusText.Partially_Filled;
      return OrderStatus;
    }
    case OrderStatusResponse.Rejected: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Rejected
          : OrderStatusText.Rejected;
      return OrderStatus;
    }

    case OrderStatusResponse.Fully_Filled: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Fully_Filled
          : OrderStatusText.Fully_Filled;
      return OrderStatus;
    }

    case OrderStatusResponse.Sent: {
      OrderStatus =
        language === "ar" ? OrderStatusTextArabic.Sent : OrderStatusText.Sent;
      return OrderStatus;
    }
    case OrderStatusResponse.Waiting: {
      OrderStatus =
        language === "ar"
          ? OrderStatusTextArabic.Waiting
          : OrderStatusText.Waiting;
      return OrderStatus;
    }
    default:
      return "";
  }
}

export function isLoggedIn(abortController) {
  if (localStorage.getItem("user")) {
    //console.log("logged in ");
    return auth(false, abortController);
  } else {
    //console.log("not logged in ");
    return false;
  }
}

export async function auth(isfromHeader = false, abortController) {
  let getProfilesResponse = utils.getHeartBeat(abortController);
  getProfilesResponse
    .then((data) => {
      
      if (Number(data.data) > 0) return true;
      else {
        // if (!isfromHeader) window.appComponent.errorHandling();
       window.appComponent.errorHandling();
        return false;
      }
    })
    .finally(() => {
      if (abortController) abortController.abort();
    })
    .catch((error) => {
      if (error.response === undefined) {
        //console.log(error.message);
        return false;
      }
      let resStatus = error.response.status;
      let isAuthorized = utils.responseProcess(resStatus, true); //to check the user is logged in
      if (!isAuthorized) {
        //console.log("user unauthorized");
      }
      if (abortController) abortController.abort();
      //console.log(error.message);
      return false;
    });
}

export function dateFromString(s) {
  var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(s);
  //alert(r)

  if (r && r.length === 7) {
    return new Date(
      parseInt(r[3]),
      parseInt(r[2]) - 1,
      parseInt(r[1]),
      parseInt(r[4]),
      parseInt(r[5]),
      parseInt(r[6])
    );
  }
  return dateFromStringPlanB(s);
}
export function dateFromStringPlanC(s, withTime = false) {
  var str = s;
  str = str.replace("+0300", "");
  str = str.replace("+0200", "");
  str = str.replace("+0400", "");
  var num = parseInt(str.replace(/[^0-9]/g, ""));
  var date = new Date(num);

  var stringDate =
    (date.getMonth() + 1).toString() +
    "/" +
    date.getDate().toString() +
    "/" +
    date.getFullYear().toString() +
    (withTime
      ? " " +
      date.getHours() +
      ":" +
      date.getMinutes() +
      ":" +
      date.getSeconds() +
      (date.getHours() > 12 ? " PM" : " AM")
      : "");

  return stringDate;
}
export function dateFromStringPlanE(s, withTime = false) {
  var str = s;
  // str = str.replace("+0300", "")
  // str = str.replace("+0200", "")
  // str = str.replace("+0400", "")
  // var num = parseInt(str.replace(/[^0-9]/g, ""));
  var date = new Date(str);

  var stringDate =
    (date.getMonth() + 1).toString() +
    "/" +
    date.getDate().toString() +
    "/" +
    date.getFullYear().toString() +
    (withTime
      ? " " +
      date.getHours() +
      ":" +
      date.getMinutes() +
      ":" +
      date.getSeconds() +
      (date.getHours() > 12 ? " PM" : " AM")
      : "");

  return stringDate;
}
export function dateFromStringPlanD(s) {
  var str = s;
  str = str.replace("+0300", "");
  str = str.replace("+0200", "");
  str = str.replace("+0400", "");
  var num = parseInt(str.replace(/[^0-9]/g, ""));
  var date = new Date(num);

  // var stringDate = (date.getMonth() + 1).toString() + "/" + date.getDate().toString() + "/" + date.getFullYear().toString()

  return date;
}
export function dateFromStringPlanB(s) {
  try {
    var strMod = s.replace(/\ /gi, "");
    strMod = strMod.replace(/\:/gi, "");
    strMod = strMod.replace(/\-/gi, "");
    var r = /\d*(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})(\d{2})/.exec(strMod);
    //alert("planb",r)
    if (r && r.length === 7) {
      return new Date(
        parseInt(r[3]),
        parseInt(r[2]) - 1,
        parseInt(r[1]),
        parseInt(r[4]),
        parseInt(r[5]),
        parseInt(r[6])
      );
    }
  } catch (e) {
    console.error(e);
  }
  return new Date(); //ragheb  //ragheb //nbo ETRADE-11
}

//check if string is parseable to JSON
export function isJsonString(str) {
  if (str === null) {
    return false;
  }
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/* Is child descendant from parent */
export function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

//date to string
export function dateToString(d, dateOnly) {
  var str =
    twoDigitNumberToString(d.getDate()) +
    twoDigitNumberToString(d.getMonth() + 1) +
    d.getFullYear();
  if (dateOnly) str += "000000";
  else
    str +=
      twoDigitNumberToString(d.getHours()) +
      twoDigitNumberToString(d.getMinutes()) +
      twoDigitNumberToString(d.getSeconds());
  return str;
}

//returns yyyy-MM-dd
export function dateToFormatyyyyMMdd(d, dateOnly) {
  let date = dateToString(d, dateOnly); //returns: 25052021000000
  let day = date.substring(0, 2);
  let month = date.substring(2, 4);
  let year = date.substring(4, 8);
  let returnedDate = year + "-" + month + "-" + day;
  return returnedDate;
}

//by mhmd ramadan
export function DateFromYYYYMMDDtoDDMMYYYY(str, separator = "-") {
  if (str == undefined || str == null || str == 0 || str == "0") {
    return "-";
  }
  return str
    .split("")
    .slice(6, 8)
    .toString()
    .replace(",", "")
    .concat(
      separator.concat(
        str
          .split("")
          .slice(4, 6)
          .toString()
          .replace(",", "")
          .concat(
            separator.concat(
              str
                .split("")
                .slice(0, 4)
                .toString()
                .replace(",", "")
                .replace(",", "")
                .replace(",", "")
            )
          )
      )
    );
}

//returns a string date: dd-MM-yyyy hh:mm:ss | example: 27-01-2021 13:23:10
export function dateFrommater(d) {
  let datestring =
    ("0" + d.getDate()).slice(-2) +
    "-" +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    "-" +
    d.getFullYear() +
    " " +
    ("0" + d.getHours()).slice(-2) +
    ":" +
    ("0" + d.getMinutes()).slice(-2) +
    ":" +
    ("0" + d.getSeconds()).slice(-2);
  return datestring;
}

export function yyyymmdd() {
  var now = new Date();
  var y = now.getFullYear();
  var m = now.getMonth() + 1;
  var d = now.getDate();
  return "" + y + (m < 10 ? "0" : "") + m + (d < 10 ? "0" : "") + d;
}

//return date with format 'ddMMyyyyHHmmss'
export function dateTimeFillFormat(date) {
  return moment(date).format("ddMMyyyyHHmmss");
}
//return date with format 'ddMMyyyyHHmmss'
export function dateTimeFillFormat2(dates) {
  let date_ob = dates;

  // adjust 0 before single digit date
  let date = ("0" + date_ob.getDate()).slice(-2);

  // current month
  let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

  // current year
  let year = date_ob.getFullYear();

  // current hours
  let hours = "00";

  // current minutes
  let minutes = "00";

  // current seconds
  let seconds = "00";
  return date + month + year + hours + minutes + seconds;
}

export function twoDigitNumberToString(dig) {
  if (dig >= 10) return dig.toString();
  return "0" + dig;
}

//example: 100,000 will be returned: 100k
export function nFormatter(num, digits) {
  if (num === null) {
    return null;
  } // terminate early
  if (num === 0) {
    return "0";
  } // terminate early
  /* digits = (!digits || digits < 0) ? 0 : digits; // number of decimal places to show
  var b = (num).toPrecision(2).split("e"), // get power
    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
    c = k < 1 ? num.toFixed(0 + digits) : (num / Math.pow(10, k * 3)).toFixed(1 + digits), // divide by power
    d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
    e = d + ['', ' K', ' M', ' B', ' T',' P', ' E'][k]; // append power */
  let zeros = "";
  if (digits !== undefined && (digits !== null) & (digits > 0)) {
    zeros += "."; //place a point before zeros
    for (let i = 0; i < digits; i++) {
      zeros += "0";
    }
  }
  let e = numeral(num).format("0" + zeros + " a");
  return e;
}

//convert string to html
export function convertStringToHtml(desc) {
  let linkEN = "";
  if (desc !== null) {
    linkEN = desc;
    var rg =
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    var substring = "<a href";

    if (linkEN.match(rg) && linkEN.includes(substring) === false) {
      linkEN = linkEN.replace(/[<]br[^>]*[>]/gi, " <br/> ");
      linkEN = linkEN.replace(/;/g, "; ");
      linkEN = linkEN.replace(/&/g, " &");
      linkEN = linkEN.replace(/http:/g, " http:");
      linkEN = linkEN.replace(/https:/g, " https:");
      linkEN = linkEN.replace(rg, "<a href='$1' target='_blank' >$1</a>");
    }
  }

  return linkEN;
}

//get language
export function getCurrentLanguage() {
  let language = "en";
  if (localStorage.getItem("language") !== null) {
    if (localStorage.getItem("language") === "ar") language = "ar";
    else language = "en";
  }
  return language;
}

export function getMarketStatusName(StatusCode, i18n) {

  switch (StatusCode) {
    case "0001":
      return i18n.t("Pre_Open");
    case "0002":
      return i18n.t("Open");
    case "0003":
      return i18n.t("Continuous");
    case "0004":
      return i18n.t("Closed");
    case "0005":
      return i18n.t("Suspended");
    case "0006":
      return i18n.t("Pre_Close");
    case "0007":
      return i18n.t("Closing");
    case "0008":
      return i18n.t("Late_Trading");
    case "0009":
      return i18n.t("EOD_Monitoring");
    case "0010":
      return i18n.t("Preclose-Adjustment");
    case "0011":
      return i18n.t("Trade-At-Last");
    case "0012":
      return i18n.t("Post-Close");
    case "0013":
      return i18n.t("intraDayAction");
    default:
      return "";
  }
}

export function getComponentPermission(
  permData,
  ParentCode,
  ChildCode = "-1",
  isfromScreen = false
) {
  let result = false;
  if (permData !== null && permData !== undefined && permData.length > 0) {
    if (isfromScreen) {
      let Check2 = permData.filter(
        (perm) => perm.ParentCode === ParentCode && perm.ChildCode === ChildCode
      );
      if (Check2 !== undefined && Check2 !== null && Check2.length > 0)
        result = true;
    } else {
      let Check = permData.filter(
        (perm) => perm.ChildCode === ParentCode && perm.ParentCode === "0"
      );
      if (Check !== undefined && Check !== null && Check.length > 0)
        result = true;
    }

    // permData.forEach(element => {
    //   if (!isfromScreen) {
    //     if (element.ChildCode === ParentCode) {
    //       result = true;
    //     }
    //   }
    //   else {
    //
    //     if (element.ParentCode === ParentCode && element.ChildCode === ChildCode) {
    //       result = true;
    //     }
    //   }
    // });
  }
  return result;
}

/* export function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      areObjects && !deepEqual(val1, val2) ||
      !areObjects && val1 !== val2
    ) {
      return false;
    }
  }

  return true;
}

export function isObject(object) {
  return object !== null && typeof object === 'object';
} */

/************ End Section 1 ************/

/* Section 2: AgGrid Functions  */

/* Numbers Comparator */
export function numberSort(num1, num2) {
  return num1 - num2;
}

// DATE COMPARATOR FOR SORTING
export function dateComparator(date1, date2) {
  let date1Number = monthToNum(date1);
  let date2Number = monthToNum(date2);

  if (date1 === null && date2 === null) {
    return 0;
  }
  if (date1 === null) {
    return -1;
  }
  if (date2 === null) {
    return 1;
  }

  return date1Number - date2Number;
}

// HELPER FOR DATE COMPARISON
export function monthToNum(date) {
  if (date === undefined || date === null || date.length === 0 || isNaN(date)) {
    return null;
  }

  // date from response: "11012021023313"
  let yearNumber = date.substring(4, 8);
  let monthNumber = date.substring(2, 4);
  let dayNumber = date.substring(0, 2);
  let timeNumber = date.substring(8);

  let result = yearNumber * 10000 + monthNumber * 100 + dayNumber + timeNumber;
  // 29/08/2004 => 20040829 2021/01/0010
  return result;
}

export function dateSort(a, b) {
  return a.getTime() - b.getTime();
}

export function datetimeformatterAgGrid(params, isAgGrid = true) {
  let value = isAgGrid ? params.value : params;
  let date = dateFromString(value);
  return date.toLocaleString("en-US");
}

export function ValidityCodeFormatterAgGrid(params) {
  let value = params.value.toString();

  if (value.length < 4) {
    if (value.length == 2) value = "00" + value;
    else if (value.length == 1) value = "000" + value;
  }

  switch (value) {
    case Constants.OrderValidityResponse.Day:
      return "Day";
    case Constants.OrderValidityResponse.GTC:
      return "GTC";
    case Constants.OrderValidityResponse.GTD:
      return "GTD";
    case Constants.OrderValidityResponse.GTW:
      return "GTW";
    case Constants.OrderValidityResponse.GTM:
      return "GTM";
    case Constants.OrderValidityResponse.FOK:
      return "FOK";
    case Constants.OrderValidityResponse.FAK:
      return "FAK";
    default:
      return "";
  }

  // if (params.value === "0001")
  //   return "Day";
  // else if (params.value === "0002")
  //   return "GTC";
  // else if (params.value === "0003")
  //   return "GTD";
  // else if (params.value === "0004")
  //   return "GTW";
  // else if (params.value === "0005")
  //   return "GTM";
  // else if (params.value === "0006")
  //   return "FOK";
  // else if (params.value === "0007")
  //   return "FAK";
  // else
  //   return "";
}
export function ValidityCodeFormatter(values, language = "en") {
  let value = values.toString();
  let ValidityCode = "";
  if (value.length < 4) {
    if (value.length == 2) value = "00" + value;
    else if (value.length == 1) value = "000" + value;
  }
  switch (value) {
    case Constants.OrderValidityResponse.Day: {
      ValidityCode = language === "ar" ? "يوم واحد" : "Day";
      return ValidityCode;
    }
    case Constants.OrderValidityResponse.GTC:
      return "GTC";
    case Constants.OrderValidityResponse.GTD:
      return "GTD";
    case Constants.OrderValidityResponse.GTW:
      return "GTW";
    case Constants.OrderValidityResponse.GTM:
      return "GTM";
    case Constants.OrderValidityResponse.FOK:
      return "FOK";
    case Constants.OrderValidityResponse.FAK:
      return "FAK";
    default:
      return value;
  }
}

export function BuySellFormatterAgGrid(params) {
  if (params.value === "B") return "Buy";
  else if (params.value === "S") return "Sell";
  else return "";
}

/************ End Section 2 ************/

/* Section 3: Global Constant */

export const TopsEnum = Object.freeze({
  TopGainers: "topGainer",
  TopLoosers: "topLooser",
  TopVolume: "topVolume",
  TopTrades: "topTrades",
  TopTurnover: "topTurnover",
});

/* End Section 3 */

/* empty cache function */
export function emptyCache() {
  if ("caches" in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
  setTimeout(() => window.location.reload());
}

/* Orders Functions */

export function getSelectedAccountBySymbol(
  exchange,
  account,
  allAccount,
  customThis
) {
  let found = false;

  for (let x = 0; x < allAccount.length; x++) {
    found = undefined;

    if (
      allAccount[x].ClientID === account.ClientID &&
      allAccount[x].Exchange === exchange
    ) {
      found = true;
      console.error("found=" + found);
      return allAccount[x];
    }
  }
  if (!found) {
    customThis.errorNotify(
      "Selected company does not exist with the selected account"
    );
    return null;
  }
}

export function UnformatNumber(value) {
  if (Constants.config.CompanyName !== "NBO") return value;
  if (value) return value.replace(/,/g, "");
  else return "";
}

export function getCustodianID(CustodianText, symbols) {
  for (var i in symbols) {
    var val = symbols[i];

    if (val.DescE === CustodianText || val.DescA === CustodianText) {
      return val.ID;
    }
  }
  return "";
}

export function getExchangeStatusCode(exchangeID, markets) {
  if (markets.length > 0 && markets[0].ClientID !== "") {
    for (let x = 0; x < markets.length; x++) {
      if (markets[x].ExchangeID === exchangeID) return markets[x].StatusCode;
    }
  }
  return "";
}

export function calculateShares(useOrderValue, thisParam) {
  if (thisParam.state.symbolDetails.Symbol === "") return;
  let selectedSymbol = thisParam.state.symbolDetails;
  //let expectedQty;
  let orderId =
    thisParam.state.order.OrderID !== null
      ? thisParam.state.order.OrderID
      : "-1"; // which means that if there is and order i.e _order then set the orderid of this order otherwise add -1
  let bsFlag = thisParam.state.orderType; //OrderType
  let cash = useOrderValue ? thisParam.state.orderValueInputNotDisabled : "-1";
  let shares_price =
    thisParam.state.price.toString().trim().length > 0
      ? parseFloat(thisParam.state.price)
      : 0;
  //let shares_quantity = UnformatNumber(thisParam.state.quantity).toString().trim().length > 0
  //? parseInt(UnformatNumber(thisParam.state.quantity))
  //: 0;

  let validity = thisParam.state.selectedValidityDateType.ID;
  let validityDate = thisParam.state.validityDate;
  if ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") && thisParam.state.isIPOChange) {
    validityDate = new Date(thisParam.state.validityDate);
  } else {
    validityDate = thisParam.state.validityDate;

  }
  if (shares_price === 0) {
    if (bsFlag === "B") shares_price = parseFloat(selectedSymbol.MaxPrice);
    else shares_price = parseFloat(selectedSymbol.MinPrice);
  }

  var new_validity =
    Constants.config.CompanyName === "QSC"
      ? validity + " " + dateToString(validityDate, false)
      : validity + dateToString(validityDate, false);

  let allAccounts = [...thisParam.props.accounts];
  /* expectedQty = custom.calculateSharesService(
      getSelectedAccountBySymbol(selectedSymbol.Exchange, custom.state.selectedAccount, allAccounts),
      custom.state.symbolDetails.Symbol,
      custom.state.symbolDetails.MarketType,
      bsFlag,
      cash, shares_price, orderId, validity, new_validity, bsFlag); */

  let account = getSelectedAccountBySymbol(
    selectedSymbol.Exchange,
    thisParam.state.selectedAccount,
    allAccounts
  );
  let symbol = thisParam.state.symbolDetails.Symbol;
  let marketType = thisParam.state.symbolDetails.MarketType;
  let orderType = bsFlag;
  //let cash = cash;
  //let price = shares_price;
  //let orderId = orderId;
  let validityCode = validity;
  let Validity = new_validity;
  let Side = bsFlag;
  let user = JSON.parse(localStorage.getItem("user"));
  let typeCode = marketType;
  let usercat = user.UserType;
  let portmang = user.BrokerID;
  let memberid = user.BrokerID;
  let compinit = user.CompInit;
  let url =
    Constants.calculatesShares +
    account.MainClientID +
    "/" +
    account.AccountID +
    "/" +
    account.NIN +
    "/" +
    symbol +
    "/" +
    orderType +
    "/" +
    cash +
    "/" +
    shares_price +
    "/" +
    orderId +
    "/" +
    usercat +
    "/" +
    user.UCode +
    "/" +
    portmang +
    "/" +
    memberid +
    "/" +
    compinit +
    "/" +
    account.ClientID +
    "/" +
    typeCode +
    "/" +
    validityCode +
    "/" +
    Validity +
    "/" +
    Side +
    "/" +
    localStorage.getItem("WebCode");

  thisParam.setIsLoaderVisible(true);
  //console.log("logging out...");
  let calculatesSharesResponse = utils.calculatesShares(url);
  calculatesSharesResponse
    .then((response) => {
      thisParam.setIsLoaderVisible(false);
      //console.log("#CalculatesShares response: ", response.data);
      thisParam.setState({ quantity: response.data }, () => {
        //lastEditRajaa callGetRiskManagement(false, thisParam);
        switchRiskManagementType(false, thisParam);
      });
    })
    .catch((error) => {
      thisParam.setIsLoaderVisible(false);
      //console.log("error", error);
    });
}

/* called multiple in component */
export function callGetRiskManagement(
  isConfirmAndSubmit = false,
  thisParam,
  isModify = false,
  BtnClicked = false
) {
  // console.log("callGetRiskManagementscreenid", thisParam.state.screenid)
  if (isConfirmAndSubmit && BtnClicked) {
    validateAndConfirmOrder(thisParam, isModify);
    return;
  }

  let options = { withCredentials: true };

  //from local storage
  let user = JSON.parse(localStorage.getItem("user")); /* Error */
  let userType = user["UserType"];
  let uCode = user["UCode"];
  let borkerId = user["BrokerID"];
  let compInit = user["CompInit"];
  let webCode = user["WebCode"];

  let price = 0;
  if (thisParam.state.price !== 0 && thisParam.state.price !== "") {
    price = thisParam.state.price;
  } else {
    price = thisParam.state.symbolDetails.MaxPrice;
  }
  //
  price = thisParam.state.marketOrderTypeSelected === "1" ? "0" : price;
  let validityDate = thisParam.state.validityDate;

  if ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") && thisParam.state.isIPOChange) {
    validityDate = dateToString(new Date(thisParam.state.validityDate));
  } else {
    validityDate = dateToString(thisParam.state.validityDate);
  }

  if (thisParam.state.selectedAccount === null) {
    setTimeout(() => {
      //lastEditRajaa callGetRiskManagement(isConfirmAndSubmit, thisParam);
      switchRiskManagementType(isConfirmAndSubmit, thisParam);
    }, 500);
    return;
  }
  let url =
    "MainClientID: " +
    thisParam.state.selectedAccount.MainClientID +
    "/" +
    "AccountID: " +
    thisParam.state.selectedAccount.AccountID +
    "/" +
    "NIN: " +
    thisParam.state.selectedAccount.NIN +
    "/" +
    "Symbol: " +
    thisParam.state.symbolDetails.Symbol +
    "/" +
    "orderType: " +
    thisParam.state.orderType +
    "/" +
    "quantity: " +
    (thisParam.state.quantity === null || thisParam.state.quantity === ""
      ? "0"
      : thisParam.state.quantity) +
    "/" +
    "price: " +
    (thisParam.state.marketOrderTypeSelected === "1" ? "0" : price) +
    "/" +
    "userType: " +
    userType +
    "/" +
    "uCode: " +
    uCode +
    "/" +
    "borkerId: " +
    borkerId +
    "/" +
    "compInit: " +
    compInit +
    "/" +
    "ClientID: " +
    thisParam.state.selectedAccount.ClientID +
    "/" +
    "MarketType: " +
    thisParam.state.symbolDetails.MarketType +
    "/" +
    "selectedValidityDateType: " +
    thisParam.state.selectedValidityDateType.ID +
    "/";
  //console.log("riskManagement", url)
  let obj = {
    MainClientID: thisParam.state.selectedAccount.MainClientID,
    AccountID: thisParam.state.selectedAccount.AccountID,
    NIN: thisParam.state.selectedAccount.NIN,
    Symbol: thisParam.state.symbolDetails.Symbol,
    OrderType: thisParam.state.orderType,
    Qty: thisParam.state.quantity === null || thisParam.state.quantity === "" ? "0" : thisParam.state.quantity,
    Price: thisParam.state.marketOrderTypeSelected === "1" ? "0" : price,
    OrderID: isModify ? thisParam.state.orderToModify.OrderID : "-1",
    UserCat: userType,
    UCode: uCode,
    PortMang: borkerId,
    MemberID: borkerId,
    CompInit: compInit,
    IncludeMargin: "Y",
    IncludeFacil: "Y",
    ClientID: thisParam.state.selectedAccount.ClientID,
    TypeCode: thisParam.state.symbolDetails.MarketType,
    ValidityCode: thisParam.state.selectedValidityDateType.ID,
    Validity: validityDate,
    settType: "-1",
    CustodyID: "-1",
    webCode: webCode,
    Leverage: thisParam.state.LeverageValue.toString(),
  };

  var riskManagementResponse = utils.GetRiskManagment(obj, thisParam);
  riskManagementResponse
    .then((response) => response.data)
    .then((data) => {
      // console.log("#BuyOrdersEntry getRiskManagement response: ", data);
      thisParam.setState(
        {
          riskManagement: {
            AccountID: data.AccountID,
            Approval_Type: data.Approval_Type,
            AvailBal: data.AvailBal,
            BANK: data.BANK,
            BANK_ACCOUNT_NO: data.BANK_ACCOUNT_NO,
            BuyOrders: data.BuyOrders,
            BuyPower: data.BuyPower,
            BuyTrades: data.BuyTrades,
            CLIENT_NAME_A: data.CLIENT_NAME_A,
            CLIENT_NAME_E: data.CLIENT_NAME_E,
            Cash: data.Cash,
            ClientID: data.ClientID,
            FacilitiesAmt: data.FacilitiesAmt,
            Flag: data.Flag,
            FlagMsgA: data.FlagMsgA,
            FlagMsgE: data.FlagMsgE,
            MSValidation: data.MSValidation,
            MarginAmnt: data.MarginAmnt,
            MemberID: data.MemberID,
            NIN: data.NIN,
            OffLineOrderDate: data.OffLineOrderDate,
            OrderValue: data.OrderValue,
            SellOrders: data.SellOrders,
            SellTrades: data.SellTrades,
            Shares: data.Shares,
            UnpostedCRTrxns: data.UnpostedCRTrxns,
            UnpostedDBTrxns: data.UnpostedDBTrxns,
            broker_ID: data.broker_ID,
            fromCurrentScreen: false,
            PopulatedRiskManagement: false,
            MaxLeverage: data.MaxLeverage,
          },
          orderValueInput: data.OrderValue,
        },
        () => {
          
          if (
            thisParam.state.riskManagement.FlagMsgE !== "" &&
            thisParam.state.isfillDatafromMarketWatch !== undefined
          ) {
            if (thisParam.state.isfillDatafromMarketWatch)
              if (
                isConfirmAndSubmit &&
                thisParam.state.riskManagement.FlagMsgE === "" &&
                BtnClicked
              ) {
                //console.log("e.FlagMsgE", thisParam.state.riskManagement.FlagMsg)
                // thisParam.errorNotify(thisParam.state.riskManagement.FlagMsgE)
                validateAndConfirmOrder(thisParam);
              }
          } else if (
            thisParam.state.riskManagement.Flag === "13" ||
            thisParam.state.riskManagement.Flag === "17" ||
            thisParam.state.riskManagement.Flag === "19"
          ) {
            // console.log("e.FlagMsgE", thisParam.state.riskManagement.FlagMsgE)
            var msgText = thisParam.props.i18n.language === "ar" ? thisParam.state.riskManagement.FlagMsgA : thisParam.state.riskManagement.FlagMsgE;
            errorNotify(msgText, thisParam.props.i18n.language);
          }

          thisParam.props.changeSymbol(null, null, null, null, null, null, false);

          if (thisParam.state.selectedValidityDateType.ID === "0001") {
            //Day
            validityDateChecker(thisParam, data.OffLineOrderDate);
          }

          if ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false")) {
            let result = thisParam.props.symbols.find((obj) => {
              return obj.Symbol === thisParam.state.symbolDetails.Symbol
            });
            if (result !== undefined && result !== null) {

              var OffLineOrderDate = utils
                .dateFromString(data.OffLineOrderDate)
                .toLocaleString("en-US");

              var IPOValidityDate = utils
                .dateFromString(result.IPOValidityDate)
                .toLocaleString("en-US");

              //OffLineOrderDate = Date(OffLineOrderDate)

              //  var IPOValidityDate = Date(result.IPOValidityDate);

              // let dateObj = new Date(OffLineOrderDate);
              // dateObj =  dateObj.toDateString();

              // let dateObjIPO = new Date(IPOValidityDate);
              // dateObjIPO =  dateObjIPO.toDateString();

              if (IPOValidityDate > OffLineOrderDate) {
                if (thisParam.props.lookups !== null && thisParam.props.lookups !== undefined) {
                  var tif = thisParam.props.lookups.filter((look) => (look.Type === "TIF" && look.ID !== "0001"))
                  if (tif.length !== 0) {

                    tif.forEach(item => {
                      if (item.ID === "0003") {
                        thisParam.setState({ selectedValidityDateType: item }, () => {
                          validityDateChecker(thisParam, IPOValidityDate, true)
                        })
                      }
                    })

                    thisParam.setState({
                      validityDateTypes: tif,
                      isLookupsPupulated: true,
                      isIPOChange: true
                      // isIPOValidityDatePopulated : true
                    })
                  }
                }

              } else {
                if (thisParam.props.lookups !== null && thisParam.props.lookups !== undefined) {
                  var tif = thisParam.props.lookups.filter((look) => (look.Type === "TIF"))
                  if (tif.length !== 0) {

                    tif.forEach(item => {
                      if (item.ID === "0001") {
                        thisParam.setState({ selectedValidityDateType: item }, () => {
                          validityDateChecker(thisParam, data.OffLineOrderDate, false)
                        })
                      }
                    })

                    thisParam.setState({
                      validityDateTypes: tif,
                      isLookupsPupulated: true,
                      isIPOChange: false
                      // isIPOValidityDatePopulated : true
                    })
                  }
                }
              }
            }
          }
        }
      );
    })
    .finally(() => {
      if (thisParam.abortController) thisParam.abortController.abort();
    })
    .catch((error) => {
      if (thisParam.abortController) thisParam.abortController.abort();
      //console.log(error);
    });
}

export function callGetRiskManagementCash(isConfirmAndSubmit = false, thisParam, isModify = false, BtnClicked = false) {
  // console.log("callGetRiskManagementscreenid", thisParam.state.screenid)
  if (isConfirmAndSubmit && BtnClicked) {
    validateAndConfirmOrder(thisParam, isModify);

    return;
  }

  let options = { withCredentials: true };

  //from local storage
  let user = JSON.parse(localStorage.getItem("user")); /* Error */
  let userType = user["UserType"];
  let uCode = user["UCode"];
  let borkerId = user["BrokerID"];
  let compInit = user["CompInit"];
  let webCode = user["WebCode"];

  let price = 0;
  if (thisParam.state.price !== 0 && thisParam.state.price !== "") {
    price = thisParam.state.price;
  } else {
    price = thisParam.state.symbolDetails.MaxPrice;
  }
  //
  price = thisParam.state.marketOrderTypeSelected === "1" ? "0" : price;
  let validityDate = dateToString(thisParam.state.validityDate);

  if (thisParam.state.selectedAccount === null) {
    setTimeout(() => {
      //lastEditRajaa callGetRiskManagement(isConfirmAndSubmit, thisParam);
      switchRiskManagementType(isConfirmAndSubmit, thisParam);
    }, 500);
    return;
  }

  let obj = {
    MainClientID: thisParam.state.selectedAccount.MainClientID,
    AccountID: thisParam.state.selectedAccount.AccountID,
    NIN: thisParam.state.selectedAccount.NIN,
    Symbol: thisParam.state.symbolDetails.Symbol,
    OrderType: thisParam.state.orderType,
    Qty: thisParam.state.quantity === null || thisParam.state.quantity === "" ? "0" : thisParam.state.quantity,
    Price: thisParam.state.marketOrderTypeSelected === "1" ? "0" : price,
    OrderID: isModify ? thisParam.state.orderToModify.OrderID : "-1",
    UserCat: userType,
    UCode: uCode,
    PortMang: borkerId,
    MemberID: borkerId,
    CompInit: compInit,
    IncludeMargin: "Y",
    IncludeFacil: "Y",
    ClientID: thisParam.state.selectedAccount.ClientID,
    TypeCode: thisParam.state.symbolDetails.MarketType,
    ValidityCode: thisParam.state.selectedValidityDateType.ID,
    Validity: validityDate,
    settType: "-1",
    CustodyID: "-1",
    webCode: webCode,
    Leverage: thisParam.state.LeverageValue.toString(),
  };

  var riskManagementResponse = utils.GetRiskManagmentCash(obj, thisParam);
  riskManagementResponse
    .then((response) => response.data)
    .then((data) => {
      // console.log("#BuyOrdersEntry getRiskManagement response: ", data);
      thisParam.setState(
        {
          riskManagement: {
            AccountID: data.AccountID,
            Approval_Type: data.Approval_Type,
            AvailBal: data.AvailBal,
            BANK: data.BANK,
            BANK_ACCOUNT_NO: data.BANK_ACCOUNT_NO,
            BuyOrders: data.BuyOrders,
            BuyPower: data.BuyPower,
            BuyTrades: data.BuyTrades,
            CLIENT_NAME_A: data.CLIENT_NAME_A,
            CLIENT_NAME_E: data.CLIENT_NAME_E,
            Cash: data.Cash,
            ClientID: data.ClientID,
            FacilitiesAmt: data.FacilitiesAmt,
            Flag: data.Flag,
            FlagMsgA: data.FlagMsgA,
            FlagMsgE: data.FlagMsgE,
            MSValidation: data.MSValidation,
            MarginAmnt: data.MarginAmnt,
            MemberID: data.MemberID,
            NIN: data.NIN,
            OffLineOrderDate: data.OffLineOrderDate,
            OrderValue: data.OrderValue,
            SellOrders: data.SellOrders,
            SellTrades: data.SellTrades,
            Shares: data.Shares,
            UnpostedCRTrxns: data.UnpostedCRTrxns,
            UnpostedDBTrxns: data.UnpostedDBTrxns,
            broker_ID: data.broker_ID,
            fromCurrentScreen: false,
            PopulatedRiskManagement: false,
            MaxLeverage: data.MaxLeverage,
          },
          orderValueInput: data.OrderValue,
        },
        () => {
          if (
            thisParam.state.riskManagement.FlagMsgE !== "" &&
            thisParam.state.isfillDatafromMarketWatch !== undefined
          ) {
            if (thisParam.state.isfillDatafromMarketWatch)
              if (
                isConfirmAndSubmit &&
                thisParam.state.riskManagement.FlagMsgE === "" &&
                BtnClicked
              ) {
                //console.log("e.FlagMsgE", thisParam.state.riskManagement.FlagMsg)
                // thisParam.errorNotify(thisParam.state.riskManagement.FlagMsgE)
                validateAndConfirmOrder(thisParam);
              }
          } else if (
            thisParam.state.riskManagement.Flag === "13" ||
            thisParam.state.riskManagement.Flag === "17" ||
            thisParam.state.riskManagement.Flag === "19"
          ) {
            // console.log("e.FlagMsgE", thisParam.state.riskManagement.FlagMsgE)
            var msgText = thisParam.props.i18n.language === "ar" ? thisParam.state.riskManagement.FlagMsgA : thisParam.state.riskManagement.FlagMsgE;
            errorNotify(msgText, thisParam.props.i18n.language);
          }

          thisParam.props.changeSymbol(null, null, null, null, null, null, false);

          if (thisParam.state.selectedValidityDateType.ID === "0001") {
            //Day
            validityDateChecker(thisParam, data.OffLineOrderDate);
          }
        }
      );
    })
    .finally(() => {
      if (thisParam.abortController) thisParam.abortController.abort();
    })
    .catch((error) => {
      if (thisParam.abortController) thisParam.abortController.abort();
      //console.log(error);
    });
}

export function switchRiskManagementType(isConfirmAndSubmit = false, thisParam, isModify = false, BtnClicked = false) {
  if (localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ")
    callGetRiskManagementCash(isConfirmAndSubmit, thisParam, isModify, BtnClicked);
  else
    callGetRiskManagement(isConfirmAndSubmit, thisParam, isModify, BtnClicked);
}

/* called once in component */
export function useAllCash(thisParam) {
  //the button of All balance click
  if (thisParam.state.selectedAccount.ClientID !== "") {

    if (thisParam.state.symbolDetails.Symbol !== "") {
      calculateShares(false, thisParam);

      //calculateRisk();//to update the order value readonly textbox . and show alerts if error happens the same function I sent yesterday including validations
      //lastEditRajaa callGetRiskManagement(false, thisParam);
      switchRiskManagementType(false, thisParam);
    } else {
      errorNotify(
        thisParam.props.i18n.t("symbol_is_required"),
        thisParam.props.i18n.language
      );
    }
  } else {
    errorNotify(
      thisParam.props.i18n.t("account_is_required"),
      thisParam.props.i18n.language
    );
  }
}

/* not called in component */
export function validateAndConfirmOrder(thisParam, isModify) {
  let account = thisParam.state.selectedAccount;
  let symbol = thisParam.state.symbolDetails.Symbol;
  let custodian = "-1";

  let MarketOrderType = thisParam.state.marketOrderType;
  let validity = thisParam.state.selectedValidityDateType.ID;
  let validityDate = new Date();
  let orderDate = new Date();
  let orderType = thisParam.state.orderType;
  let MinFill = thisParam.state.MinFillQty;
  let TotalVolume = 0;
  let quantity = Number(thisParam.state.quantity);
  let remaining = 0;
  let isConditionalOrder = false;
  let orderId = isModify ? thisParam.state.orderToModify.OrderID : "-1";
  let Sett_Type = "";
  let TransferReq = false;
  let VisibleQuantity = thisParam.state.VisibleQty;
  let SmartOrderID = "";
  let Remarks = "";
  let TP_price = thisParam.state.TP_price;
  let SL_price = thisParam.state.SL_price;
  placeNewOrder(
    account,
    symbol,
    custodian,
    thisParam.state.price,
    isModify,
    MarketOrderType,
    validity,
    validityDate,
    orderDate,
    orderType,
    MinFill,
    TotalVolume,
    quantity,
    remaining,
    isConditionalOrder,
    orderId,
    Sett_Type,
    TransferReq,
    VisibleQuantity,
    SmartOrderID,
    Remarks,
    TP_price,
    SL_price,
    thisParam
  );
}

/* not called in component */
export function placeNewOrder(
  account,
  symbol,
  custodian = "-1",
  price,
  isModify = false,
  MarketOrderType,
  Validity,
  ValidityDate,
  orderDate,
  OrderType = { Buy: 0, Sell: 1 },
  MinFill,
  TotalVolume,
  quantity,
  Remaining,
  isConditionalOrder = false,
  orderId = "-1",
  Sett_Type,
  TransferReq,
  VisibleQuantity = "",
  SmartOrderID = "",
  Remarks = "",
  TP_price = "",
  SL_price = "",
  thisParam
) {
  let Symbols = [...thisParam.props.symbols]; //state of symbols lookups

  if (!account) {
    errorNotify(
      thisParam.props.i18n.t("Account_is_required"),
      thisParam.props.i18n.language
    );
    return;
  }
  //    errorNotify(thisParam.props.i18n.t("account is required"), thisParam.props.i18n.language);

  var selectedSymbol = thisParam.state.symbolDetails; //either full from beginning or get from the below for loop

  if (!symbol || symbol.length === 0) {

    errorNotify(thisParam.props.i18n.t("symbol_is_required"), thisParam.props.i18n.language);
    return;
  } else {
    for (let i in Symbols) {
      if (Symbols[i].Symbol === symbol || Symbols[i].SymbolCompanyE === symbol || Symbols[i].SymbolCompanyA === symbol) {
        selectedSymbol = Symbols[i];
        symbol = Symbols[i].Symbol;
        break;
      }
    }
    if (!selectedSymbol) {
      errorNotify(
        thisParam.props.i18n.t("please_select_a_symbol_from_the_list"),
        thisParam.props.i18n.language
      );
      return;
    }
  }
  //let symbols = thisParam.props.symbols;
  //let selectedCustodian = getCustodianID(custodian, symbols);

  if (thisParam.state.orderType === "") {
    errorNotify(thisParam.props.i18n.t("Select_order_type_[Buy or Sell]"), thisParam.props.i18n.language);
    return;
  }

  if (!quantity || parseInt(quantity) <= 0) {
    errorNotify(thisParam.props.i18n.t("quantity_is_required"), thisParam.props.i18n.language);
    return;
  }

  //let price = '';

  if (thisParam.state.price === "") {
    if (thisParam.state.marketOrderTypeSelected === "2") {
      errorNotify(thisParam.props.i18n.t("Enter_price"), thisParam.props.i18n.language);
      return;
    } else {
      price = thisParam.state.symbolDetails.MaxPrice;
    }
  } else {
    price = thisParam.state.price;
  }

  if ((parseFloat(price) < thisParam.state.symbolDetails.MinPrice || parseFloat(price) > thisParam.state.symbolDetails.MaxPrice) && (thisParam.state.IsValidateMinMax != "N")) {
    let MaxPriceValue =
      localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "IFS"
        ? thisParam.state.symbolDetails.MaxPrice
        : localStorage.getItem(Constants.localStorageConstants.company_name) ===
          "UNITED"
          ? numberFormatterWithCommasAndDigitsFixed(
            thisParam.state.symbolDetails.MaxPrice,
            4
          )
          : thisParam.state.symbolDetails.MaxPrice;

    let MinPriceValue =
      localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "IFS"
        ? thisParam.state.symbolDetails.MinPrice
        : localStorage.getItem(Constants.localStorageConstants.company_name) ===
          "UNITED"
          ? numberFormatterWithCommasAndDigitsFixed(
            thisParam.state.symbolDetails.MinPrice,
            4
          )
          : thisParam.state.symbolDetails.MinPrice;

    // thisParam.errorNotify("Price must be less than max "
    //   + MaxPriceValue +
    //   " price and greater than min price "
    //   + MinPriceValue)
    //
    var MSG = thisParam.props.i18n.t("Price_must_be_between_min") + MinPriceValue + thisParam.props.i18n.t("and") + MaxPriceValue;
    errorNotify(MSG, thisParam.props.i18n.language);
    return;
  }

  try {
    price = parseFloat(price).toString();

    if (Constants.config.CompanyName === "NBO") {
      if (
        !UnformatNumber(quantity) ||
        parseInt(UnformatNumber(quantity)) <= 0
      ) {
        errorNotify(
          thisParam.props.i18n.t("quantity_is_required"),
          thisParam.props.i18n.language
        );
        return;
      }
    } else {
      if (
        price.indexOf(".") > -1 &&
        Constants.config.CompanyName.toUpperCase() === "QATAR"
      ) {
        if (
          price.split(".")[1].length > 2 &&
          selectedSymbol.Precision === "2"
        ) {
          errorNotify(
            thisParam.props.i18n.t("price_should_not_exceed_two_decimals"),
            thisParam.props.i18n.language
          );
          return;
        }
        if (selectedSymbol.IsFund === "Y") {
          if (
            price.split(".")[1].length > 3 &&
            parseFloat(price) >= 1 &&
            selectedSymbol.Precision === "3"
          ) {
            errorNotify(
              thisParam.props.i18n.t("price_should_not_exceed_three_decimals"),
              thisParam.props.i18n.language
            );
            return;
          }
        } else {
          if (
            price.split(".")[1].length > 2 &&
            parseFloat(price) >= 1 &&
            selectedSymbol.Precision === "3"
          ) {
            errorNotify(
              thisParam.props.i18n.t("price_should_not_exceed_two_decimals"),
              thisParam.props.i18n.language
            );
            return;
          }
        }
        if (
          price.split(".")[1].length > 3 &&
          selectedSymbol.Precision === "3" &&
          parseFloat(price) < 1
        ) {
          errorNotify(
            thisParam.props.i18n.t("price_should_not_exceed_three_decimals"),
            thisParam.props.i18n.language
          );
          return;
        }
      }
    }
  } catch (e) {
    //console.log(e);
  }

  if (
    (price || parseFloat(price) <= 0 || price.length === 0) &&
    (Constants.config.CompanyName === "QNB" ||
      Constants.config.CompanyName === "CIC") &&
    MarketOrderType === MarketOrderType.Limit
  ) {
    errorNotify(
      thisParam.props.i18n.t("price_is_required"),
      thisParam.props.i18n.language
    );
    return;
  }
  if (price && selectedSymbol !== null && (parseFloat(price) > parseFloat(selectedSymbol.MaxPrice) || parseFloat(price) < parseFloat(selectedSymbol.MinPrice))) {
    //var error_msg = ""//priceisoutofrangemin_X0_max_X1

    var error_msg = "priceisoutofrangemin_X0_max_X1";
    //console.log("e.FlagMsgE", error_msg)
    //  thisParam.errorNotify(error_msg)
    return;
  }

  if (!Constants.config.AllowOfflineOrder && selectedSymbol !== null) {
    let markets = [...thisParam.state.markets];
    var status = getExchangeStatusCode(selectedSymbol.Exchange, markets);
    if (status === "0005" || status === "0004") {
      errorNotify(
        thisParam.props.i18n.t("offlineorder"),
        thisParam.props.i18n.language
      );
      return;
    }
  }

  if (!Validity || Validity.length === 0) {
    errorNotify(
      thisParam.props.i18n.t("Valdity_is_required"),
      thisParam.props.i18n.language
    );
    return;
  }


  if (["0003"].indexOf(Validity) > 0) {
    if (!ValidityDate) {
      errorNotify(
        thisParam.props.i18n.t("Validity_Date_is_required"),
        thisParam.props.i18n.language
      );
      return;
    } else if (orderDate && ValidityDate < orderDate) {
      errorNotify(
        thisParam.props.i18n.t("validitydatemustbegreaterthan"),
        thisParam.props.i18n.language
      );
      return;
    }
  }

  if (thisParam.state.ISTradingSession === "Y" && !thisParam.state.TradingSessionDisabled && thisParam.state.selectedTradingSession.ID === "" && ((localStorage.getItem(Constants.localStorageConstants.company_name)).toUpperCase() === "GLOBAL" || (localStorage.getItem(Constants.localStorageConstants.company_name)).toUpperCase() === "UNITED")) {
    errorNotify(thisParam.props.i18n.t("TradingSession_is_required"), thisParam.props.i18n.language);
    return;
  }

  if (parseInt(VisibleQuantity) > parseInt(UnformatNumber(quantity))) {
    errorNotify(
      thisParam.props.i18n.t("visiblequantitymustbelessthanquantity"),
      thisParam.props.i18n.language
    );
    return;
  }

  if (parseInt(MinFill) > parseInt(UnformatNumber(quantity))) {
    errorNotify(
      thisParam.props.i18n.t("minimumfillmustbelessthanquantity"),
      thisParam.props.i18n.language
    );
    return;
  }

  if (localStorage.getItem(Constants.localStorageConstants.company_name) === "ALRAMZ" && account.IS_MARGIN_ACC === "Y") {
    var maxL = thisParam.state.riskManagement.MaxLeverage === "null" ||
      thisParam.state.riskManagement.MaxLeverage === null
      ? "0"
      : thisParam.state.riskManagement.MaxLeverage;
    if (account.IS_MARGIN_ACC === "Y" && parseFloat(thisParam.state.LeverageValue) > parseFloat(maxL)) {
      errorNotify(thisParam.props.i18n.t("Leverage_Value_must_be_less_than_Max_Leverage"), thisParam.props.i18n.language);
      return;
    }

    if (account.IS_MARGIN_ACC === "Y" && 1 > parseFloat(thisParam.state.LeverageValue) && parseFloat(thisParam.state.LeverageValue) < parseFloat(maxL) && parseFloat(maxL) >= 1 && thisParam.state.orderType == "B") {
      errorNotify(thisParam.props.i18n.t("LeverageValueMust") + parseFloat(maxL), thisParam.props.i18n.language);
      return;
    }

    if (parseFloat(maxL) < 1)
      if (parseFloat(thisParam.state.LeverageValue) != parseFloat(maxL)) {
        errorNotify("Leverage Value must be equal Max Leverage  " + parseFloat(maxL), thisParam.props.i18n.language);
        return;
      }
  }

  //let allAccounts = [...thisParam.props.accounts];
  //var acc = getSelectedAccountBySymbol(selectedSymbol.Exchange, account, allAccounts, this);//Selected account;
  //var op = OrderType;

  var order_quantity =
    UnformatNumber(quantity).toString().trim().length > 0
      ? parseInt(UnformatNumber(quantity))
      : 0;
  var executed = (parseFloat(TotalVolume) || 0) - (parseFloat(Remaining) || 0);
  var total_volume = executed + order_quantity;
  //var remaining = order_quantity;
  //var totalQty = Constants.config.RealTimeOrders ? total_volume : remaining;
  var order_price = 0;
  if (isConditionalOrder) {
    //  createCondtional();
  } else {
    if (selectedSymbol === null) return;
    order_price = price.toString().trim().length > 0 ? parseFloat(price) : 0;

    if (isNaN(order_price) || isNaN(parseFloat(order_price))) {
      price = 0;
    }

    //var bsFlag = OrderType === OrderType.Buy ? 'B' : 'S';
    //var risk_validity = (Constants.config.CompanyName === "QSC") ? Validity + ' ' + dateToString(ValidityDate, false) : Validity + dateToString(ValidityDate, false);

    //call api

    let options = { withCredentials: true };

    //from local storage
    let user = JSON.parse(localStorage.getItem("user"));
    let userType = user["UserType"];
    let uCode = user["UCode"];
    let borkerId = user["BrokerID"];
    let compInit = user["CompInit"];
    let webCode = user["WebCode"];

    let priceForApi = 0;
    if (thisParam.state.price !== 0 && thisParam.state.price !== "") {
      priceForApi = thisParam.state.price;
    } else {
      priceForApi = thisParam.state.symbolDetails.MaxPrice;
    }
    let validityDate = thisParam.state.validityDate;

    if ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") && thisParam.state.isIPOChange) {
      validityDate = dateToString(new Date(thisParam.state.validityDate));
    } else {
      validityDate = dateToString(thisParam.state.validityDate);
    }
    thisParam.setIsLoaderVisible(true);
    // let url = Constants.getRiskManagement +
    //   thisParam.state.selectedAccount.MainClientID + '/' +
    //   thisParam.state.selectedAccount.AccountID + '/' +
    //   thisParam.state.selectedAccount.NIN + '/' +
    //   thisParam.state.symbolDetails.Symbol + '/' +
    //   thisParam.state.orderType + '/' +
    //   thisParam.state.quantity + '/' +
    //   priceForApi + '/' + orderId + '/' +
    //   userType + '/' +
    //   uCode + '/' +
    //   borkerId + '/' +
    //   borkerId + '/' +
    //   compInit + '/' +
    //   thisParam.state.selectedAccount.ClientID + '/' +
    //   thisParam.state.symbolDetails.MarketType + '/' +
    //   thisParam.state.selectedValidityDateType.ID + '/' +
    //   validityDate + "/" +
    //   "-1/-1/" +
    //   webCode;

    let url =
      "MainClientID: " +
      thisParam.state.selectedAccount.MainClientID +
      "/" +
      "AccountID: " +
      thisParam.state.selectedAccount.AccountID +
      "/" +
      "NIN: " +
      thisParam.state.selectedAccount.NIN +
      "/" +
      "Symbol: " +
      thisParam.state.symbolDetails.Symbol +
      "/" +
      "orderType: " +
      thisParam.state.orderType +
      "/" +
      "quantity: " +
      (thisParam.state.quantity === null || thisParam.state.quantity === ""
        ? "0"
        : thisParam.state.quantity) +
      "/" +
      "price: " +
      (thisParam.state.marketOrderTypeSelected === "1" ? "0" : price) +
      "/" +
      "userType: " +
      userType +
      "/" +
      "uCode: " +
      uCode +
      "/" +
      "borkerId: " +
      borkerId +
      "/" +
      "compInit: " +
      compInit +
      "/" +
      "ClientID: " +
      thisParam.state.selectedAccount.ClientID +
      "/" +
      "MarketType: " +
      thisParam.state.symbolDetails.MarketType +
      "/" +
      "selectedValidityDateType: " +
      thisParam.state.selectedValidityDateType.ID +
      "/";
    //console.log("riskManagement", url)

    let obj = {
      MainClientID: thisParam.state.selectedAccount.MainClientID,
      AccountID: thisParam.state.selectedAccount.AccountID,
      NIN: thisParam.state.selectedAccount.NIN,
      Symbol: thisParam.state.symbolDetails.Symbol,
      OrderType: thisParam.state.orderType,
      Qty:
        thisParam.state.quantity === null || thisParam.state.quantity === ""
          ? "0"
          : thisParam.state.quantity,
      Price:
        thisParam.state.marketOrderTypeSelected === "1" ? "0" : priceForApi,
      OrderID: isModify ? thisParam.state.orderToModify.OrderID : "-1",
      UserCat: userType,
      UCode: uCode,
      PortMang: borkerId,
      MemberID: borkerId,
      CompInit: compInit,
      IncludeMargin: "Y",
      IncludeFacil: "Y",
      ClientID: thisParam.state.selectedAccount.ClientID,
      TypeCode: thisParam.state.symbolDetails.MarketType,
      ValidityCode: thisParam.state.selectedValidityDateType.ID,
      Validity: validityDate,
      settType: "-1",
      CustodyID: "-1",
      webCode: webCode,
      Leverage: thisParam.state.LeverageValue.toString(),
    };

    var riskManagementResponse =
      localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "ALRAMZ"
        ? utils.GetRiskManagmentCash(obj, thisParam)
        : utils.GetRiskManagment(obj, thisParam);
    riskManagementResponse
      .then((response) => response.data)
      .then((data) => {
        thisParam.setState(
          {
            riskManagement: {
              AccountID: data.AccountID,
              Approval_Type: data.Approval_Type,
              AvailBal: data.AvailBal,
              BANK: data.BANK,
              BANK_ACCOUNT_NO: data.BANK_ACCOUNT_NO,
              BuyOrders: data.BuyOrders,
              BuyPower: data.BuyPower,
              BuyTrades: data.BuyTrades,
              CLIENT_NAME_A: data.CLIENT_NAME_A,
              CLIENT_NAME_E: data.CLIENT_NAME_E,
              Cash: data.Cash,
              ClientID: data.ClientID,
              FacilitiesAmt: data.FacilitiesAmt,
              Flag: data.Flag,
              FlagMsgA: data.FlagMsgA,
              FlagMsgE: data.FlagMsgE,
              MSValidation: data.MSValidation,
              MarginAmnt: data.MarginAmnt,
              MemberID: data.MemberID,
              NIN: data.NIN,
              OffLineOrderDate: data.OffLineOrderDate,
              OrderValue: data.OrderValue,
              SellOrders: data.SellOrders,
              SellTrades: data.SellTrades,
              Shares: data.Shares,
              UnpostedCRTrxns: data.UnpostedCRTrxns,
              UnpostedDBTrxns: data.UnpostedDBTrxns,
              broker_ID: data.broker_ID,
              MaxLeverage: data.MaxLeverage,
            },
          },
          () => {
            let e = thisParam.state.riskManagement;
            if (
              e.Flag === "6" &&
              Constants.config.CompanyName === "NBO" &&
              !TransferReq
            ) {
              //CallBankTransfareRequest(e, selectedSymbol, totalQty, "confirmMessage"); to be done later
              return;
            } else if (e.Flag !== "0") {
              //  console.log("e.FlagMsgE", e.FlagMsgE)
              // if (Constants.config.CompanyName !== "CIC")
              //  console.log("e.FlagMsgE", e.FlagMsgE)
              var msgText = thisParam.props.i18n.language === "ar" ? e.FlagMsgA : e.FlagMsgE;
              errorNotify(
                thisParam.props.i18n.t(msgText),
                thisParam.props.i18n.language
              );
              // if (thisParam.state.isfillDatafromMarketWatch !== undefined)
              //   if (!thisParam.state.isfillDatafromMarketWatch) {
              //     console.log("e.FlagMsgE", e.FlagMsgE)
              //     thisParam.errorNotify(e.FlagMsgE)
              //   }
              //   // thisParam.errorNotify(e.FlagMsgE)
              //   else {
              //     if (e.FlagMsgE.indexOf('No Data') > -1) {

              //       e.FlagMsgE = "Company not traded to this account";
              //       e.FlagMsgA = "الشركة لا يمكن تداولها على هذا الحساب";
              //       thisParam.errorNotify(e.FlagMsgE)
              //     }
              //     if (thisParam.state.isfillDatafromMarketWatch !== undefined)
              //       if (!thisParam.state.isfillDatafromMarketWatch) {
              //         console.log("e.FlagMsgE", e.FlagMsgE)
              //         thisParam.errorNotify(e.FlagMsgE)
              //       }

              //     //thisParam.errorNotify(e.FlagMsgE)
              //   }

              return;
            }

            //offline order
            /* var orderTypeCode = '-1';
          switch (MarketOrderType) {
            case thisParam.state.MarketOrderType.Market:
              orderTypeCode = '1';
              break;
            case thisParam.state.MarketOrderType.Limit:
              orderTypeCode = '2';
              break;
            default:
              orderTypeCode = "-1";
              break;
          } */
            if (isModify /* && _order */) {
              //def = Services.modifyOrder(selectedSymbol.Symbol, bsFlag, totalQty.Remaining, price, Validity, orderTypeCode, orderId);
              thisParam.confirmAndSubmitOrder(total_volume, true);
            } else {
              thisParam.confirmAndSubmitOrder(total_volume);
              //def = Services.createOrder(selectedSymbol.Symbol, bsFlag, totalQty.Remaining, price, Validity, orderTypeCode);
            }
          }
        );

        thisParam.setIsLoaderVisible(false);
      })
      .finally(() => {
        if (thisParam.abortController) thisParam.abortController.abort();
      })
      .catch((error) => {
        if (thisParam.abortController) thisParam.abortController.abort();
        errorNotify(
          thisParam.props.i18n.t("Error_please_try_again_later"),
          thisParam.props.i18n.language
        );
        thisParam.setIsLoaderVisible(false);
      });
  }
}

/* called once in component */
export function callAddOrder(TotalVolume, thisParam, type = 1) {
  /* new signalr add/modify order */
  // new -> type = 1
  // modify -> type = 2

  let order = {};
  let isModify = type === 2;
  let selectedSymbol = thisParam.state.symbolDetails;
  let user = JSON.parse(localStorage.getItem("user"));
  //let selectedAccount = thisParam.state.selectedAccount;
  let newDate = new Date();

  let date = dateFrommater(newDate);

  order.OrderID = isModify ? thisParam.state.orderToModify.OrderID : "";
  order.SymbolCode = selectedSymbol.SymbolID;
  order.Exchange = selectedSymbol.Exchange;
  order.BookCode = "0001";
  order.BrokerID = user.BrokerID;
  order.AccountID = thisParam.state.selectedAccount.AccountID;
  order.Symbol = selectedSymbol.Symbol;

  let price = "";
  if (thisParam.state.price === "") {
    if (thisParam.state.orderType === "B") {
      price = thisParam.state.symbolDetails.MaxPrice;
    } else {
      price = thisParam.state.symbolDetails.MinPrice;
    }
  } else {
    price = thisParam.state.price;
  }
  order.Price = thisParam.state.marketOrderTypeSelected === "1" ? "0" : String(price);
  order.ValidityCode = thisParam.state.selectedValidityDateType.ID;

  if ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") && thisParam.state.isIPOChange) {
    order.ValidityDate = dateFrommater(new Date(thisParam.state.validityDate));
  } else {
    order.ValidityDate = dateFrommater(thisParam.state.validityDate);

  }

  let total = thisParam.state.quantity;
  let remaining = thisParam.state.quantity;
  let execqty = 0;

  if (isModify)
    if (thisParam.state.orderToModify.StatusCode === "P") {
      execqty = Number(thisParam.state.orderToModify.TotalVolume) - Number(thisParam.state.orderToModify.Remaining);
      total = execqty + parseInt(thisParam.state.quantity);
      remaining = Number(total) - execqty;
    }

  order.TotalVolume = String(total);
  order.Remaining = String(remaining);

  /* order.TotalVolume = String(parseInt(thisParam.state.quantity))
  order.Remaining = isModify ? remaining : String(parseInt(thisParam.state.quantity)); */
  //
  order.SourceCode = "c";
  order.StatusCode = isModify ? thisParam.state.orderToModify.StatusCode : "W"; //isCancel ? "C" : "W";
  order.EntryDate = isModify ? "" : date; // bs iza new order
  order.ModifyDate = /* isModify ? */ date; /* : "" */ // bs iza modify order
  order.UserID = user.UCode;
  order.OrigUserID = user.UCode;
  order.MarketTypeCode = selectedSymbol.MarketType; // symbol.MarketType
  order.Source2Code = "c";
  order.MinFillQty = thisParam.state.MinFillQty;
  //order.VisibleQty = thisParam.state.VisibleQty;

  order.VisibleQty = thisParam.state.selectedExecutionRole === "0020" && localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? -1 : thisParam.state.VisibleQty; //Mustafa changes

  order.OrderTypeCode = thisParam.state.marketOrderTypeSelected;
  if (order.Price === "0") {
    order.OrderTypeCode = "1";
  }
  order.NIN = thisParam.state.selectedAccount.NIN;
  order.ProcSentFlag = "Y";
  order.MarketOrderID = "";
  order.OriginCode = "E";
  order.IntOrderID = "";
  order.TP_price = thisParam.state.TP_price;
  order.SL_price = thisParam.state.SL_price;

  order.TrxnID = isModify ? String((parseInt(thisParam.state.orderToModify.TrxnID) ?? 0) + 1) : "0";
  if (thisParam.state.orderType === "B") {
    order.SellBuyFlag = "B";
    order.msgCode = isModify ? "C15" : "C11";
  } else {
    order.SellBuyFlag = "S";
    order.msgCode = isModify ? "C14" : "C10";
  }
  order.AccountNameA = thisParam.state.selectedAccount.ClientNameA;
  order.AccountNameE = thisParam.state.selectedAccount.ClientNameE; // account.ClientNameE
  order.Remark = ""; // remarks
  order.SenderSubID = "";
  order.BuyerMember = "";
  order.SellerMember = "";
  order.AvgExePrice = "";
  order.IsinCode = ""; // symbol.IsinCode
  order.FIXOrderID = "";
  order.ClientID = thisParam.state.selectedAccount.ClientID;
  //order.ClientID = thisParam.state.selectedAccount.AccountID;
  order.RejectReason = "";

  order.TR_price = "";
  order.Max_TR_price = String(order.Price);
  order.TR_Price_is_perc = "";
  order.BE_Price = "";
  order.SPL_Order_flag = "N";
  order.ApprovalStatusCode = user.WebCode;
  order.ApprovalTypeCode = thisParam.state.riskManagement.MSValidation; // key
  order.StopLossPx = "";
  order.SenderCompanyID = "";
  order.LocalValue = "";
  order.SymbolLongName = "";
  order.LastUpdateTime = "01-01-2000 22:51:14"; //weird
  order.SmartOrderID = ""; // SmartOrderID

  // order.Sett_Type = ""; //selectedOrder.SettlementType.value
  // order.CustodianID = ""; //selectedOrder.CustodianID.id // CustodianID

  order.Sett_Type = localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" && thisParam.state.orderType === "S" ? thisParam.state.selectedSettelmentType : ""; //Mustafa changes
  order.CustodianID = localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? thisParam.state.selectedCustodian : ""; //Mustafa changes

  order.IP_Address = localStorage.getItem("ipAddress");
  order.Leverage = parseFloat(thisParam.state.LeverageValue);
  order.TradingSessionID = type === 2 ? "" : thisParam.state.selectedTradingSession.ID;

  // if (localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false" && thisParam.state.IsPortfolioPopulited) {
  //   if (thisParam.state.profitLossData.length > 0) {
  //     var checkSymbol = thisParam.state.profitLossData.find((el) => el.Symbol === order.Symbol);
  //     if (checkSymbol === undefined || checkSymbol === null) {
  //       errorNotify(thisParam.props.t("notEnableTrade"), thisParam.props.i18n.language);
  //       return
  //     }

  //   }
  // }
  if (thisParam.props.signalr_connection !== undefined && thisParam.props.signalr_connection !== null && thisParam.props.signalr_connection.state === 1) {
    let order1 = order;
    order = [order];

    console.log("order to invoke: ", order1, " username: ", localStorage.getItem("username"));
    // thisParam.props.signalr_connection.proxies.myhub.invoke("sendAddOrderRequest", localStorage.getItem("username"), order)

    thisParam.props.signalr_connection.proxies.myhub
      .invoke("sendAddOrderRequest", localStorage.getItem("username"), order1)
      .then((res) => {
        if (!res) {
          errorNotify(thisParam.props.t("MsgErrNetWork"), thisParam.props.i18n.language);
        }
      });

    //Mustafa changes BasketOrder
    // if (thisParam.props.fromBasketOrder) {
    //   console.log(
    //     "order to invoke: ",
    //     order1,
    //     " username: ",
    //     localStorage.getItem("username")
    //   );
    //   addBasketOrderDetails(order1, thisParam);
    // } else if (thisParam.props.updateFromBasketOrder) {
    //   console.log(
    //     "order to invoke: ",
    //     order1,
    //     " username: ",
    //     localStorage.getItem("username")
    //   );
    //   ModifyBasketOrderDetails(order1, thisParam);
    // } else {
    //   console.log("invoke", order1);
    //   // thisParam.props.signalr_connection.proxies.myhub.invoke("sendAddOrderRequest", localStorage.getItem("username"), order)
    //   thisParam.props.signalr_connection.proxies.myhub
    //     .invoke("sendAddOrderRequest", localStorage.getItem("username"), order1)
    //     .then((res) => {
    //       if (!res) {
    //         errorNotify(
    //           thisParam.props.t("MsgErrNetWork"),
    //           thisParam.props.i18n.language
    //         );
    //       }
    //     });
    // }
  } else {
    errorNotify(thisParam.props.i18n.t("error"), thisParam.props.i18n.language);
  }

  return;
}

//Mustafa changes
export function addBasketOrderDetails(orderObj, thisParam) {
  // basketOrderArr.value = orderObj;
  thisParam.props.setBasketOrderObject([orderObj]);

  let params = {
    AccountID: orderObj.AccountID,
    AccountNameA: orderObj.AccountNameA,
    AccountNameE: orderObj.AccountNameE,
    ApprovalStatusCode: orderObj.ApprovalStatusCode,
    ApprovalTypeCode: orderObj.ApprovalTypeCode,
    AvgExePrice: orderObj.AvgExePrice,
    BE_Price: orderObj.BE_Price,
    B_GroupName: thisParam.state.selectedGroupName,
    B_OutOfMarketDate: orderObj.B_OutOfMarketDate,
    B_OutOfMarketType: orderObj.B_OutOfMarketType,
    BookCode: orderObj.BookCode,
    BrokerID: orderObj.BrokerID,
    BuyerMember: orderObj.BuyerMember,
    ClientID: orderObj.ClientID,
    CompanyShortNameA: orderObj.CompanyShortNameA,
    CompanyShortNameE: orderObj.CompanyShortNameE,
    CustodianID: orderObj.CustodianID,
    EntryDate: orderObj.EntryDate,
    Exchange: orderObj.Exchange,
    ExecOrderComm: orderObj.ExecOrderComm,
    FIXOrderID: orderObj.FIXOrderID,
    IntOrderID: orderObj.IntOrderID,
    vIsinCode: orderObj.IsinCode,
    vvLastUpdateTime: "/Date(928138800000+0300)/", //"19-01-2023 15:52:02",
    LocalValue: orderObj.LocalValue,
    MarketOrderID: orderObj.MarketOrderID,
    MarketTypeCode: orderObj.MarketTypeCode,
    MaxPrice: orderObj.MaxPrice,
    Max_TR_price: orderObj.Max_TR_price,
    MinFillQty: orderObj.MinFillQty.toString(),
    MinPrice: orderObj.MinPrice,
    ModifyDate: orderObj.ModifyDate,
    NIN: orderObj.NIN,
    No_of_trades: orderObj.No_of_trades,
    OrdComm: orderObj.OrdComm,
    OrderID: orderObj.OrderID,
    OrderTypeCode: orderObj.OrderTypeCode,
    OrigUserID: orderObj.OrigUserID,
    OriginCode: orderObj.OriginCode,
    Precision: orderObj.Precision,
    Price: orderObj.Price,
    ProcSentFlag: orderObj.ProcSentFlag,
    RejectReason: orderObj.RejectReason,
    Remaining: orderObj.Remaining,
    Remark: orderObj.Remark,
    SL_price: orderObj.SL_price.toString(),
    SMART_ORDER_ID: orderObj.SMART_ORDER_ID,
    SPL_Order_flag: orderObj.SPL_Order_flag,
    SellBuyFlag: orderObj.SellBuyFlag,
    SellerMember: orderObj.SellerMember,
    SenderCompanyID: orderObj.SenderCompanyID,
    SenderSubID: orderObj.SenderSubID,
    Source2Code: orderObj.Source2Code,
    SourceCode: orderObj.SourceCode,
    StatusCode: orderObj.StatusCode,
    StopLossPx: orderObj.StopLossPx,
    Symbol: orderObj.Symbol,
    SymbolCode: orderObj.SymbolCode,
    SymbolLongName: orderObj.SymbolLongName,
    TP_price: orderObj.TP_price.toString(),
    TR_Price_is_perc: orderObj.TR_Price_is_perc,
    TR_price: orderObj.TR_price,
    TotalVolume: orderObj.TotalVolume,
    TrxnID: orderObj.TrxnID,
    UserID: localStorage.getItem("WebCode"),
    ValidityCode: orderObj.ValidityCode,
    ValidityDate: orderObj.ValidityDate,
    VisibleQty: orderObj.VisibleQty.toString(),
    cur_code: orderObj.cur_code,
    msgCode: orderObj.msgCode,
  };

  let params2 = {
    AccountID: orderObj.AccountID,
    AccountNameA: orderObj.AccountNameA,
    AccountNameE: orderObj.AccountNameE,
    ApprovalStatusCode: orderObj.ApprovalStatusCode,
    ApprovalTypeCode: orderObj.ApprovalTypeCode,
    AvgExePrice: "",
    BE_Price: "",
    B_GroupName: "",
    B_OutOfMarketDate: "",
    B_OutOfMarketType: orderObj.B_OutOfMarketType,
    BookCode: orderObj.BookCode,
    BrokerID: orderObj.BrokerID,
    BuyerMember: "",
    ClientID: orderObj.ClientID,
    CompanyShortNameA: "",
    CompanyShortNameE: "",
    CustodianID: "",
    EntryDate: orderObj.EntryDate,
    Exchange: orderObj.Exchange,
    ExecOrderComm: "",
    FIXOrderID: "",
    IntOrderID: "",
    IsinCode: "",
    LastUpdateTime: "/Date(928138800000+0300)/",
    LocalValue: "",
    MarketOrderID: "",
    MarketTypeCode: orderObj.MarketTypeCode,
    MaxPrice: "",
    Max_TR_price: orderObj.Max_TR_price,
    MinFillQty: orderObj.MinFillQty,
    MinPrice: "",
    ModifyDate: orderObj.ModifyDate,
    NIN: orderObj.NIN,
    No_of_trades: "",
    OrdComm: "",
    OrderID: "",
    OrderTypeCode: orderObj.OrderTypeCode,
    OrigUserID: orderObj.OrigUserID,
    OriginCode: orderObj.OriginCode,
    Precision: "",
    Price: orderObj.Price,
    ProcSentFlag: orderObj.ProcSentFlag,
    RejectReason: "",
    Remaining: orderObj.Remaining,
    Remark: "",
    SL_price: orderObj.SL_price,
    SMART_ORDER_ID: "",
    SPL_Order_flag: orderObj.SPL_Order_flag,
    SellBuyFlag: orderObj.SellBuyFlag,
    SellerMember: "",
    SenderCompanyID: "",
    SenderSubID: "",
    Source2Code: orderObj.Source2Code,
    SourceCode: orderObj.SourceCode,
    StatusCode: orderObj.StatusCode,
    StopLossPx: "",
    Symbol: orderObj.Symbol,
    SymbolCode: "12",
    SymbolLongName: "",
    TP_price: orderObj.TP_price,
    TR_Price_is_perc: "",
    TR_price: "",
    TotalVolume: orderObj.TotalVolume,
    TrxnID: orderObj.TrxnID,
    UserID: "82",
    ValidityCode: orderObj.ValidityCode,
    ValidityDate: orderObj.ValidityDate,
    VisibleQty: orderObj.VisibleQty,
    cur_code: "",
    msgCode: orderObj.msgCode,
  };

  let AddBasketOrderResponse = utils.addBasketOrderDetails(params);
  AddBasketOrderResponse.then((response) => {
    console.log("response AddBankIBAN called", response);

    if (response.data) {
      if (response.data !== "false" && response.data !== "") {
        successNotify(
          this.props.t("Add To Basket Order"),
          this.props.i18n.language
        );
      } else {
        errorNotify(
          thisParam.props.i18n.t("Error"),
          thisParam.props.i18n.language
        );
      }
    } else {
      errorNotify(
        thisParam.props.i18n.t("Error"),
        thisParam.props.i18n.language
      );
    }

    //this.clearAll(e);
  }).catch((error) => {
    errorNotify(error, "EN");
  });
}

//Mustafa changes
export function ModifyBasketOrderDetails(updateOrderObj, thisParam) {
  // basketOrderArr.value = orderObj;
  thisParam.props.setBasketOrderObject([updateOrderObj]);

  let params = {
    AccountID: updateOrderObj.AccountID,
    AccountNameA: updateOrderObj.AccountNameA,
    AccountNameE: updateOrderObj.AccountNameE,
    ApprovalStatusCode: updateOrderObj.ApprovalStatusCode,
    ApprovalTypeCode: updateOrderObj.ApprovalTypeCode,
    AvgExePrice: updateOrderObj.AvgExePrice,
    BE_Price: updateOrderObj.BE_Price,
    B_GroupName: thisParam.state.selectedGroupName,
    B_OutOfMarketDate: updateOrderObj.B_OutOfMarketDate,
    B_OutOfMarketType: updateOrderObj.B_OutOfMarketType,
    BookCode: updateOrderObj.BookCode,
    BrokerID: updateOrderObj.BrokerID,
    BuyerMember: updateOrderObj.BuyerMember,
    ClientID: updateOrderObj.ClientID,
    CompanyShortNameA: updateOrderObj.CompanyShortNameA,
    CompanyShortNameE: updateOrderObj.CompanyShortNameE,
    CustodianID: updateOrderObj.CustodianID,
    EntryDate: updateOrderObj.EntryDate,
    Exchange: updateOrderObj.Exchange,
    ExecOrderComm: updateOrderObj.ExecOrderComm,
    FIXOrderID: updateOrderObj.FIXOrderID,
    IntOrderID: updateOrderObj.IntOrderID,
    IsinCode: updateOrderObj.IsinCode,
    LastUpdateTime: "/Date(928138800000+0300)/", //"19-01-2023 15:52:02",
    LocalValue: updateOrderObj.LocalValue,
    MarketOrderID: updateOrderObj.MarketOrderID,
    MarketTypeCode: updateOrderObj.MarketTypeCode,
    MaxPrice: updateOrderObj.MaxPrice,
    Max_TR_price: updateOrderObj.Max_TR_price,
    MinFillQty: updateOrderObj.MinFillQty.toString(),
    MinPrice: updateOrderObj.MinPrice,
    ModifyDate: updateOrderObj.ModifyDate,
    NIN: updateOrderObj.NIN,
    No_of_trades: updateOrderObj.No_of_trades,
    OrdComm: updateOrderObj.OrdComm,
    OrderID: thisParam.state.basketOrderIDUpdated,
    OrderTypeCode: updateOrderObj.OrderTypeCode,
    OrigUserID: updateOrderObj.OrigUserID,
    OriginCode: updateOrderObj.OriginCode,
    Precision: updateOrderObj.Precision,
    Price: updateOrderObj.Price,
    ProcSentFlag: updateOrderObj.ProcSentFlag,
    RejectReason: updateOrderObj.RejectReason,
    Remaining: updateOrderObj.Remaining,
    Remark: updateOrderObj.Remark,
    SL_price: updateOrderObj.SL_price.toString(),
    SMART_ORDER_ID: updateOrderObj.SMART_ORDER_ID,
    SPL_Order_flag: updateOrderObj.SPL_Order_flag,
    SellBuyFlag: updateOrderObj.SellBuyFlag,
    SellerMember: updateOrderObj.SellerMember,
    SenderCompanyID: updateOrderObj.SenderCompanyID,
    SenderSubID: updateOrderObj.SenderSubID,
    Source2Code: updateOrderObj.Source2Code,
    SourceCode: updateOrderObj.SourceCode,
    StatusCode: updateOrderObj.StatusCode,
    StopLossPx: updateOrderObj.StopLossPx,
    Symbol: updateOrderObj.Symbol,
    SymbolCode: updateOrderObj.SymbolCode,
    SymbolLongName: updateOrderObj.SymbolLongName,
    TP_price: updateOrderObj.TP_price.toString(),
    TR_Price_is_perc: updateOrderObj.TR_Price_is_perc,
    TR_price: updateOrderObj.TR_price,
    TotalVolume: updateOrderObj.TotalVolume,
    TrxnID: updateOrderObj.TrxnID,
    UserID: localStorage.getItem("WebCode"),
    ValidityCode: updateOrderObj.ValidityCode,
    ValidityDate: updateOrderObj.ValidityDate,
    VisibleQty: updateOrderObj.VisibleQty.toString(),
    cur_code: updateOrderObj.cur_code,
    msgCode: updateOrderObj.msgCode,
  };

  console.log("modyfy", params);

  let ModifyBasketResponse = utils.ModifyBasketOrderDetails(params);
  ModifyBasketResponse.then((response) => {
    console.log("response AddBankIBAN called", response);
    if (response.data) {
    } else {
      //errorNotify(this.props.t("error"), this.props.i18n.language);
    }

    //this.clearAll(e);
  }).catch((error) => {
    errorNotify(error, "EN");
  });
}
export function callCancelOrder(props, errorNotify) {
  if (
    props.signalr_connection !== undefined &&
    props.signalr_connection !== null &&
    props.signalr_connection.state === 1
  ) {
    let order = {};
    let selectedSymbol = props.data;
    let user = JSON.parse(localStorage.getItem("user"));
    let newDate = new Date();
    let date = dateFrommater(newDate);

    order.OrderID = selectedSymbol.OrderID ?? "";
    order.SymbolCode = selectedSymbol.Symbol;
    order.Exchange = selectedSymbol.Exchange;
    order.BookCode = "0001";
    order.BrokerID = user.BrokerID;
    order.AccountID = selectedSymbol.AccountID;
    order.Symbol = selectedSymbol.Symbol;

    order.Price = selectedSymbol.Price ?? "";

    let value = selectedSymbol.ValidityCode.toString();
    if (!value.includes("0001,0002,0003,0004,0005,0006,0007")) {
      let values = value;
      // if (value.length < 4) {
      //   if (value.length == 2)
      //     value = "00" + value;
      //   else if (value.length == 1)
      //     value = "000" + value;
      // }
      switch (values) {
        case "Day":
          value = "0001";
          break;
        case "GTC":
          value = "0002";
          break;
        case "GTD":
          value = "0003";
          break;
        case "GTW":
          value = "0004";
          break;
        case "GTM":
          value = "0005";
          break;
        case "FOK":
          value = "0006";
          break;
        case "FAK":
          value = "0007";
          break;
        case "1":
          value = "0001";
          break;
        case "2":
          value = "0002";
          break;
        case "3":
          value = "0003";
          break;
        case "4":
          value = "0006";
          break;
        case "5":
          value = "0005";
          break;
        case "6":
          value = "0006";
          break;
        case "7":
          value = "0007";
          break;
      }
    }

    order.ValidityCode = value ?? "";
    order.ValidityDate = selectedSymbol.ValidityDate ?? "";

    order.TotalVolume = selectedSymbol.TotalVolume ?? "";
    order.Remaining = selectedSymbol.Remaining ?? "";

    order.SourceCode = "c";
    order.StatusCode = selectedSymbol.StatusCode ?? "";

    order.EntryDate = selectedSymbol.EntryDate ?? "";
    order.ModifyDate = date;

    order.UserID = user.UCode;
    order.OrigUserID = user.UCode;
    order.MarketTypeCode = selectedSymbol.MarketTypeCode; // symbol.MarketType
    order.Source2Code = "c";
    order.MinFillQty = selectedSymbol.MinFillQty ?? "";

    order.VisibleQty = selectedSymbol.VisibleQty ?? "";
    order.OrderTypeCode = selectedSymbol.OrderTypeCode ?? "";

    order.NIN = selectedSymbol.NIN ?? "";
    order.ProcSentFlag = "Y";
    order.MarketOrderID = "";
    order.OriginCode = "E";
    order.IntOrderID = "";
    order.TP_price = selectedSymbol.TP_price;
    order.SL_price = selectedSymbol.SL_price;

    order.TrxnID = String((parseInt(selectedSymbol.TrxnID ?? "0") ?? 0) + 1);

    order.SellBuyFlag = selectedSymbol.SellBuyFlag ?? "";

    if (selectedSymbol.orderType === "B") {
      if (
        selectedSymbol.StatusCode.toUpperCase() === "W" ||
        selectedSymbol.StatusCode.toUpperCase() === "T"
      ) {
        order.msgCode = "C27";
      } else {
        order.msgCode = "C19";
      }
    } else {
      if (
        selectedSymbol.StatusCode.toUpperCase() === "W" ||
        selectedSymbol.StatusCode.toUpperCase() === "T"
      ) {
        order.msgCode = "C26";
      } else {
        order.msgCode = "C18";
      }
    }

    order.AccountNameA = selectedSymbol.AccountNameA ?? "";
    order.AccountNameE = selectedSymbol.AccountNameE ?? "";
    order.Remark = selectedSymbol.Remark ?? "";

    order.SenderSubID = "";
    order.BuyerMember = "";
    order.SellerMember = "";

    order.AvgExePrice = selectedSymbol.AvgExePrice ?? "";
    order.IsinCode = "";
    order.FIXOrderID = " ";

    order.ClientID = selectedSymbol.ClientID ?? "";

    order.RejectReason = "";
    order.TR_price = "";

    order.Max_TR_price = selectedSymbol.Max_TR_price ?? "";

    order.TR_Price_is_perc = "";
    order.BE_Price = "";
    order.SPL_Order_flag = "N";

    order.ApprovalStatusCode = user.WebCode;
    order.ApprovalTypeCode = ""; // key
    order.StopLossPx = "";
    order.SenderCompanyID = "";
    order.LocalValue = "";
    order.SymbolLongName = "";
    order.LastUpdateTime = "0001-01-01T00:00:00"; //weird
    order.SmartOrderID = ""; // SmartOrderID

    order.Sett_Type = ""; //selectedOrder.SettlementType.value
    order.CustodianID = ""; //selectedOrder.CustodianID.id // CustodianID
    order.IP_Address = localStorage.getItem("ipAddress");
    //console.log("order to cancel: ", order, " username: ", localStorage.getItem("username"));
    // thisParam.props.signalr_connection.proxies.myhub.invoke("sendAddOrderRequest", localStorage.getItem("username"), order)
    props.signalr_connection.proxies.myhub.invoke(
      "sendAddOrderRequest",
      localStorage.getItem("username"),
      order
    );
  } else {
    errorNotify("error");
  }
}

export function validityDateChecker(thisParam, validityDate = null, isIPOChange = false) {
  
  let today = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() + 1);

  let OffLineOrderDate = utils
    .dateFromStringDateOnly(thisParam.state.riskManagement.OffLineOrderDate)
    .toLocaleString("en-US");

  let OffLineOrderDateformat = new Date();
  if (OffLineOrderDate !== null && OffLineOrderDate !== "") {
    if (OffLineOrderDate.includes(","))
      OffLineOrderDateformat = new Date(OffLineOrderDate);
    else {
      OffLineOrderDateformat.setHours(today.getHours());
      OffLineOrderDateformat.setTime(today.getTime());
      OffLineOrderDateformat.setSeconds(today.getSeconds());
      OffLineOrderDateformat.setFullYear(
        Number(OffLineOrderDate.split("/")[2])
      );
      OffLineOrderDateformat.setMonth(
        Number(OffLineOrderDate.split("/")[1]) - 1
      );
      OffLineOrderDateformat.setDate(Number(OffLineOrderDate.split("/")[0]));

      // OffLineOrderDateformat = new Date(OffLineOrderDate.split("/")[2], Number(OffLineOrderDate.split("/")[1]) - 1, OffLineOrderDate.split("/")[0] );
    }
  }

  if (validityDate !== null) {
    today = validityDate;
  }
  if (thisParam.state.selectedValidityDateType.ID === "0001") {
    //Day
    thisParam.setState({
      isValidityDatePickerDisabled: true,
      validityDate: OffLineOrderDateformat,
    });
  } else if (thisParam.state.selectedValidityDateType.ID === "0002") {
    //GTC
    if (validityDate !== null) {
      today = validityDate;
    } else {
      today.setFullYear(today.getFullYear() + 1);
    }
    thisParam.setState({
      isValidityDatePickerDisabled: true,
      validityDate: today,
    });
  } else if (
    thisParam.state.selectedValidityDateType.ID === "0003" &&
    thisParam.state.isModify === false
  ) {
    //GTD

    // thisParam.setState({ isValidityDatePickerDisabled: false, validityDate: fromDate })
    thisParam.setState({
      isValidityDatePickerDisabled: false,
      validityDate: OffLineOrderDateformat,
    });
  } else if (
    thisParam.state.selectedValidityDateType.ID === "0003" &&
    thisParam.state.isModify === true
  ) {
    //GTD
    var x = isIPOChange ? new Date(validityDate) : validityDate
    if (x !== null) {
      thisParam.setState({
        isValidityDatePickerDisabled: false,
        validityDate: x,
      });
    } else {
      thisParam.setState({
        isValidityDatePickerDisabled: false,
        validityDate: OffLineOrderDateformat,
      });
    }
    // thisParam.setState({ isValidityDatePickerDisabled: false, validityDate: fromDate })
  } else if (
    thisParam.state.selectedValidityDateType.ID === "0003" &&
    thisParam.state.isModify === undefined
  ) {
    //GTD

    // thisParam.setState({ isValidityDatePickerDisabled: false, validityDate: fromDate }) 

    var x = isIPOChange ? new Date(validityDate) : OffLineOrderDateformat;
    thisParam.setState({
      isValidityDatePickerDisabled: false,
      validityDate: x,
    });
  } else if (thisParam.state.selectedValidityDateType.ID === "0004") {
    //GTW

    if (validityDate !== null) {
      today = validityDate;
    } else {
      var endingday = localStorage.getItem("last_Work_day");
      today = getNextDayOfTheWeek(endingday);
      // var endingday = "Thursday"
      // switch (localStorage.getItem("Region")) {
      //   case "UAE":
      //     //  need to be changed in the begining of the year to Friday on UAE Only
      //     endingday = "Friday"
      //     break;
      //   case "OMAN":
      //     endingday = "Thursday"
      //     break;
      //   case "QATAR":
      //     endingday = "Thursday"
      //     break;
      //   default:
      //     endingday = "Thursday"
      //     break;
      // }

      // switch (localStorage.getItem("last_Work_day")) {
      //   case "0":
      //     endingday = "Sunday"
      //     break;
      //   case "1":
      //     endingday = "Monday"
      //     break;
      //   case "2":
      //     endingday = "Tuesday"
      //     break;
      //   case "3":
      //     endingday = "Wednesday"
      //     break;
      //   case "4":
      //     endingday = "Thursday"
      //     break;
      //   case "5":
      //     endingday = "Friday"
      //     break;
      //   case "6":
      //     endingday = "Saturday"
      //     break;
      //   default:
      //     endingday = "Thursday"
      //     break;
      // }
      // today = getNextDayOfTheWeek(endingday);
    }
    thisParam.setState({
      isValidityDatePickerDisabled: true,
      validityDate: today,
    });
  } else if (thisParam.state.selectedValidityDateType.ID === "0005") {
    //GTM
    if (validityDate !== null) {
      today = validityDate;
    } else {
      var d = new Date(),
        pd = d;
      for (var o = 1; pd.getMonth() == d.getMonth() || d.getDate() != 1; o++) {
        pd = d;
        d = new Date($.now() + o * 24 * 3600000);
      }

      // today = d.setDate(-1);
      today = pd;
    }
    thisParam.setState({
      isValidityDatePickerDisabled: true,
      validityDate: today,
    });
  } else if (thisParam.state.selectedValidityDateType.ID === "0006") {
    //FOK
    thisParam.setState({
      isValidityDatePickerDisabled: true,
      validityDate: today,
    });
  } else if (thisParam.state.selectedValidityDateType.ID === "0007") {
    //FAK
    thisParam.setState({
      isValidityDatePickerDisabled: true,
      validityDate: today,
    });
  }
}

export function getNextDayOfTheWeek(
  dayName,
  excludeToday = true,
  refDate = new Date()
) {
  // const dayOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
  //   .indexOf(dayName.slice(0, 3).toLowerCase());
  var now = new Date();
  const dayOfWeek = Number(dayName);
  if (dayOfWeek < 0) return;

  refDate.setDate(
    refDate.getDate() +
    +!!excludeToday +
    ((dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7)
  );
  refDate.setHours(now.getHours());
  refDate.setTime(now.getTime());
  refDate.setSeconds(now.getSeconds());
  refDate.setDate(
    refDate.getDate() +
    +!!excludeToday +
    ((dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7)
  );
  return refDate;
}

/* select symbol in orders */
export function selectSymbol(symbol, thisParam, isHeader = false, isModify = false, isOrderScreen = false) {

  console.log("order selected symbol: ", symbol);
  thisParam.setState(
    { selectedSymbolSearchSelect: symbol, isSymbolDetailsPopulated: false, isLookupsPupulatedExecution: false },
    () => {

      let result = thisParam.props.symbols.filter((obj) => {
        return obj.Symbol === symbol;
      });
      if (result !== undefined && result !== null && result.length > 0) {
        //console.log("obj.Symbol ", result[0]);
        if (isOrderScreen)
          populateAccounts(result[0], thisParam, isHeader, isModify);
        callSignalr(symbol, result[0].MarketType, thisParam);

        thisParam.setState({ IsValidateMinMax: result[0].IsValidateMinMax, ISTradingSession: result[0].IS_US_ONLINE })
        // if (localStorage.getItem(Constants.localStorageConstants.company_name) === "GLOBAL") {
        //   thisParam.setState({ IsValidateMinMax: result[0].IsValidateMinMax, ISTradingSession: result[0].IS_US_ONLINE })

        // }
      }
      // else {
      //   errorNotify(
      //     thisParam.props.i18n.t("Something_went_wrong"),
      //     thisParam.props.i18n.language
      //   );
      // }
    }
  );
}

export function populateAccounts(SymbolData, thisParam, isHeader = false, isModify = false) {

  if (thisParam.props.allAccounts !== undefined && thisParam.props.allAccounts !== null && thisParam.props.allAccounts.length > 0) {
    //
    let accounts = thisParam.props.allAccounts.filter(
      (item) => SymbolData.Exchange === item.Exchange
    );
    if (accounts.length === 0) {
      // errorNotify(thisParam.props.i18n.t("You_dont_have_an_Account_to_trade_on_this_Symbol"), thisParam.props.i18n.language);
      thisParam.setState({
        accounts: accounts,
      });
      if ((localStorage.getItem(Constants.localStorageConstants.company_name)).toUpperCase() === "IFS") {
        thisParam.AlertMSG();
      }
      return;
    }
    // console.log("accoutntsPopulated: ", accounts);
    // console.log("thisParam.props.allAccounts ", thisParam.props.allAccounts);
    thisParam.setState(
      {
        accounts: accounts,
        isAccountSelectedFromProps: true,
      },
      () => {
        //console.log("accoutntsPopulated: ", thisParam.state.accounts);
        if (isHeader) {
          thisParam.setState({
            accountsOptions: thisParam.state.accounts.map(
              ({ AccountID, ClientNameE }) => ({
                value: AccountID,
                name: ClientNameE,
              })
            ),
          });
        }
        let existed = false;
        var display_Leverage = false;
        var countCall = 0;
        thisParam.state.accounts.forEach((item) => {
          if (
            SymbolData.Exchange === item.Exchange &&
            SymbolData.CurrCode === item.CUR_CODE &&
            SymbolData.IS_DERIVATIVE === item.ALLOW_DERIV_TRADING &&
            (SymbolData.allow_short_sell === item.cl_allow_short_sell_market ||
              SymbolData.allow_short_sell === "Y")
          ) {

            if (item.IS_MARGIN_ACC === "Y") {
              display_Leverage = true;
            } else {
              display_Leverage = false;
            }

            if (item.IS_DEFAULT_ACC === "Y") {
              existed = true;
              if (!isModify)
                thisParam.setState({
                  selectedAccount: item,
                  isAccountDropdownDisabled: false,
                  displayLeverage: display_Leverage,
                  IsPortfolioPopulited: false
                }, () => {

                  if (countCall === 0) {
                    thisParam.callgetCustodiansByClientID();
                    thisParam.callgetPortfolioForIPOQuickSell();
                    countCall = + 1;
                  }
                });
              else
                thisParam.setState({
                  isAccountDropdownDisabled: false,
                  displayLeverage: display_Leverage,
                });
            } else {
              if (!isModify)
                thisParam.setState({
                  selectedAccount: item,
                  isAccountDropdownDisabled: false,
                  displayLeverage: display_Leverage,
                  IsPortfolioPopulited: false
                }, () => {

                  if (countCall === 0) {
                    thisParam.callgetCustodiansByClientID();
                    thisParam.callgetPortfolioForIPOQuickSell();
                    countCall = + 1;
                  }
                });
              else
                thisParam.setState({
                  isAccountDropdownDisabled: false,
                  displayLeverage: display_Leverage,
                });
            }
          }
        });
        if (existed) return;
        if (!existed) {
          thisParam.state.accounts.forEach((item, index) => {
            if (item.IS_MARGIN_ACC === "Y") {
              display_Leverage = true;
            } else {
              display_Leverage = false;
            }
            if (index === 0) {
              existed = true;
              if (!isModify)
                thisParam.setState({
                  selectedAccount: item,
                  isAccountDropdownDisabled: false,
                  displayLeverage: display_Leverage,
                  IsPortfolioPopulited: false
                }, () => {

                  if (countCall === 0) {
                    thisParam.callgetCustodiansByClientID();
                    thisParam.callgetPortfolioForIPOQuickSell();
                    countCall = + 1;
                  }
                });
              else
                thisParam.setState({
                  isAccountDropdownDisabled: false,
                  displayLeverage: display_Leverage,
                });
              return;
            }
          });
        }
      }
    );
  }
}

export function callSignalr(symbol, MarketType, thisParam) {
  //window.isBuyOrdersEntry = true;
  //window.BuyOrdersEntry = thisParam;
  //window["symbolDetails"](symbol, "001");
  //console.log("BuyOrdersEntry symbol: ", symbol, " MarketType: ", MarketType);
  if (
    thisParam.props.signalr_connection !== undefined &&
    thisParam.props.signalr_connection !== null &&
    thisParam.props.signalr_connection.state === 1
  ) {
    thisParam.props.signalr_connection.proxies.myhub.invoke(
      "sendSymbolDetails",
      symbol,
      MarketType
    );
    thisParam.props.signalr_connection.proxies.myhub.invoke(
      "AddMarketWatchProfileSymbol",
      localStorage.getItem("username"),
      symbol
    );
    thisParam.props.setSymbolToSub(thisParam.props.screenid, symbol);
  } else {
    //console.log("Something went wrong.")
    // thisParam.errorNotify("Something went wrong.")
  }
}

export function getUser() {
  if (
    localStorage.getItem("user") === null ||
    localStorage.getItem("user") === undefined
  ) {
    return null;
  }
  if (!isJsonString(localStorage.getItem("user"))) {
    return null;
  }
  let user = JSON.parse(localStorage.getItem("user"));
  return user;
}

export function getExchangesWithSelected(exchanges, selectedID) {
  //to set DFM always as initial selection

  let isFound = false;
  for (let i = 0; i < exchanges.length; i++) {
    // if (exchanges[i].ExchangeID === "DFM") {
    //   isFound = true;
    // }
    if (exchanges[i].ExchangeID === selectedID) {
      isFound = true;
    }
  }

  let exchangesArray = exchanges.map((obj, index) =>
    isFound
      ? obj.ExchangeID === selectedID
        ? Object.assign(obj, { isSelected: true })
        : Object.assign(obj, { isSelected: false })
      : index === 0
        ? Object.assign(obj, { isSelected: true })
        : Object.assign(obj, { isSelected: false })
  );
  // console.log("exchangesArray", exchangesArray);
  // console.log("exchanges", exchanges);
  return exchangesArray;
}

// Get max value of an array in Javascript
export function getMaxValue(array) {
  let value = Math.max.apply(null, array);
  return value;
}

/* Global function for AgGridReact */
export function autoSizeAll(skipHeader, thisParam) {
  var allColumnIds = [];
  thisParam.gridColumnApi.getAllColumns().forEach(function (column) {
    allColumnIds.push(column.colId);
  });
  thisParam.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
}

export function getIsIPad() {
  return window.innerWidth <= 1024;
}

export function getIsMobile() {
  /*mini mobile screen*/
  return window.innerWidth <= 475;
}

export function isNight() {
  var date = new Date();
  if (date.getHours() > 19 || date.getHours() < 6) {
    return true;
  } else {
    return false;
  }
}

export function isShuaa() {
  return true;
}

export function getCompanyName() {
  return localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase();
}

export function removeExistingItem(key) {
  if (localStorage.getItem(key) !== null) localStorage.removeItem(key);
}

export function getAppTheme() {
  let appThemeClass = "app-theme-white";
  let theme = localStorage.getItem("theme");
  if (theme !== null) {
    if (theme === "dark") {
      appThemeClass = "app-theme-dark";
    }
  }
  return appThemeClass;
}

export function getAppThemeMode() {
  let themeMode = lightTheme;
  let theme = localStorage.getItem("theme");
  if (theme !== null) {
    if (theme === "dark") {
      themeMode = darkTheme;
    }
  }
  return themeMode;
}

export function getIsTickerVisible() {
  let isTickerVisible = true;
  let isTickerVisibleLocalStorage = localStorage.getItem(
    Constants.localStorageConstants.isTickerVisible
  );
  if (isTickerVisibleLocalStorage !== null) {
    if (isTickerVisibleLocalStorage === "true") {
      isTickerVisible = true;
    } else {
      isTickerVisible = false;
    }
  }
  //console.log("getIsTickerVisible: ", isTickerVisible);
  return isTickerVisible;
}

export function setIsTickerVisible(isTickerVisibleParam) {
  //console.log("setIsTickerVisible: ", isTickerVisibleParam);
  localStorage.setItem(
    Constants.localStorageConstants.isTickerVisible,
    isTickerVisibleParam
  );
}

export function getPreviousConfig() {
  var data = {
    app_path: localStorage.getItem(Constants.localStorageConstants.app_path),
    company_name: localStorage.getItem(Constants.localStorageConstants.company_name),
    Region: localStorage.getItem(Constants.localStorageConstants.Region),
    server_url: localStorage.getItem(Constants.localStorageConstants.server_url),
    chart_iq_url: localStorage.getItem(Constants.localStorageConstants.chart_iq_url),
    chart_trading_url: localStorage.getItem(Constants.localStorageConstants.chart_trading_url),
    signalr_url: localStorage.getItem(Constants.localStorageConstants.signalr_url),
    signalr_hub: localStorage.getItem(Constants.localStorageConstants.signalr_hub),
    last_Work_day: localStorage.getItem(Constants.localStorageConstants.last_Work_day),
    Foreign_Market: localStorage.getItem(Constants.localStorageConstants.Foreign_Market),
    PortfolioProvider: localStorage.getItem(Constants.localStorageConstants.PortfolioProvider),
    EnableTags: localStorage.getItem(Constants.localStorageConstants.EnableTags),
    EnableIPOQuickSell: localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell),
    EnableSymbolFullName: localStorage.getItem(Constants.localStorageConstants.EnableSymbolFullName),
    EnableMarketWatchCache: localStorage.getItem(Constants.localStorageConstants.EnableMarketWatchCache),
    signalrCallInterval: localStorage.getItem(Constants.localStorageConstants.signalrCallInterval)
  };
  return data;
}
export function SetpreviosConfig(data) {
  localStorage.setItem(Constants.localStorageConstants.app_path, data.app_path);
  localStorage.setItem(Constants.localStorageConstants.company_name, data.company_name);
  localStorage.setItem(Constants.localStorageConstants.Region, data.Region);
  localStorage.setItem(Constants.localStorageConstants.server_url, data.server_url);
  localStorage.setItem(Constants.localStorageConstants.chart_iq_url, data.chart_iq_url);
  localStorage.setItem(Constants.localStorageConstants.chart_trading_url, data.chart_trading_url);
  localStorage.setItem(Constants.localStorageConstants.signalr_url, data.signalr_url);
  localStorage.setItem(Constants.localStorageConstants.signalr_hub, data.signalr_hub);
  localStorage.setItem(Constants.localStorageConstants.last_Work_day, data.last_Work_day);
  localStorage.setItem(Constants.localStorageConstants.Foreign_Market, data.Foreign_Market);
  localStorage.setItem(Constants.localStorageConstants.PortfolioProvider, data.PortfolioProvider);
  localStorage.setItem(Constants.localStorageConstants.EnableTags, data.EnableTags);
  localStorage.setItem(Constants.localStorageConstants.EnableIPOQuickSell, data.EnableIPOQuickSell);
  localStorage.setItem(Constants.localStorageConstants.EnableSymbolFullName, data.EnableSymbolFullName);
  localStorage.setItem(Constants.localStorageConstants.EnableMarketWatchCache, data.EnableMarketWatchCache);
  localStorage.setItem(Constants.localStorageConstants.signalrCallInterval, data.signalrCallInterval);
}

export function isNullOrEmpty(str) {
  if (str != undefined && str != null && str != "") {
    return false;
  } else return true;
}

export async function getAsByteArray(file) {
  return new Uint8Array(await readFile(file));
}

function readFile(file) {
  return new Promise((resolve, reject) => {
    // Create file reader
    let reader = new FileReader();

    // Register event listeners
    reader.addEventListener("loadend", (e) => resolve(e.target.result));
    reader.addEventListener("error", reject);

    // Read file
    reader.readAsArrayBuffer(file);
  });
}

export function getKeyOfObj(Obj) {
  var keyOfNewData = Object.keys(Obj);
  return keyOfNewData;
}

export function ExchangesUpdateDisableTagValue(Obj) {

  return ""
}
export function ExchangesUpdateEnableTagValue(state, exchangesUpdateMsg, fromRedux = false) {
  // exchangesUpdateMsg = [
  //   {
  //     "ExchangeID": "XNYS",
  //     "CurrentValue": "9183.48",
  //     "Volume": "2",

  //   },
  //   {
  //     "ExchangeID": "XNAS",
  //     "CurrentValue": "9183.48",
  //     "Volume": "44",

  //   },
  //   {
  //     "ExchangeID": "TDWL",
  //     "CurrentValue": "986.31",
  //     "Volume": "5",

  //   },
  //   {
  //     "ExchangeID": "BHB",
  //     "CurrentValue": "8250.61",
  //     "ExchangeNameE": "BHB",
  //     "ExchangeNameA": "BHB",
  //     "Volume": "0",

  //   },
  //   {
  //     "ExchangeID": "CRYP",
  //     "CurrentValue": "9183.48",
  //     "ExchangeNameE": "BINANCE",
  //     "ExchangeNameA": "BINANCE",
  //     "Volume": "0",

  //   },
  //   {
  //     "ExchangeID": "DFM",
  //     "CurrentValue": "100",
  //     "ExchangeNameE": "DFM DUBAI",
  //     "ExchangeNameA": "DFM DUBAI",
  //     "Volume": "228506827",

  //   },
  //   {
  //     "ExchangeID": "ADSM",
  //     "CurrentValue": "9971.57",
  //     "ExchangeNameE": "ADSM",
  //     "ExchangeNameA": "سوق أبو ظبي",
  //     "Volume": "241239735",

  //   },
  //   {
  //     "ExchangeID": "DIFX",
  //     "CurrentValue": "3587.44",
  //     "ExchangeNameE": "DIFX",
  //     "ExchangeNameA": "سوق دبي العالمي ",
  //     "Volume": "92120",

  //   }
  // ]
  let oldOrigenalexchange = [];

  oldOrigenalexchange = fromRedux ? state.OrigenalExchanges : state

  if (
    oldOrigenalexchange !== null &&
    oldOrigenalexchange !== [] &&
    (exchangesUpdateMsg !== null) &
    (exchangesUpdateMsg !== []) &
    (exchangesUpdateMsg !== undefined) &&
    exchangesUpdateMsg.length === undefined
  ) {

    var list = []
    let oldExchange = oldOrigenalexchange.find((e) => e.ExchangeID === exchangesUpdateMsg.ExchangeID);

    if (oldExchange !== undefined && oldExchange !== null) {
      var keysOfNewData = Object.keys(exchangesUpdateMsg);
      keysOfNewData.forEach(key => {
        if (key !== "ExchangeID")
          oldExchange[key] = exchangesUpdateMsg[key];
      });
      list.push(oldExchange);
      oldOrigenalexchange.map(obj => list.find(o => o.ExchangeID === obj.ExchangeID) || obj);

      state = fromRedux ? {
        ...state,
        exchanges: oldOrigenalexchange,
      } : oldOrigenalexchange

    }

  }
  else if (
    oldOrigenalexchange !== null &&
    oldOrigenalexchange !== [] &&
    (exchangesUpdateMsg !== null) &
    (exchangesUpdateMsg !== []) &
    (exchangesUpdateMsg !== undefined) &&
    exchangesUpdateMsg.length > 0
  ) {

    let oldExchange = null;
    let list = [];

    exchangesUpdateMsg.forEach((str, idx) => {

      oldExchange = oldOrigenalexchange.find((e) => e.ExchangeID === exchangesUpdateMsg[idx].ExchangeID);
      if (oldExchange !== undefined && oldExchange !== null) {

        var keysOfNewData = Object.keys(exchangesUpdateMsg[idx]);
        keysOfNewData.forEach(key => {
          if (key !== "ExchangeID")
            oldExchange[key] = exchangesUpdateMsg[idx][key];
        });
        list.push(oldExchange);


      }
    });

    if (list.length != 0) {
      state = fromRedux ? {
        ...state,
        exchanges: list,
      } : list
    }


  }
  return state;
}
